(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[613],{

/***/ 79860:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 27957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(64834);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 64834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(86996),
    createBaseEach = __webpack_require__(27150);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 42274:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(5705),
    baseSet = __webpack_require__(26930),
    castPath = __webpack_require__(19595);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 26930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(14663),
    castPath = __webpack_require__(19595),
    isIndex = __webpack_require__(88688),
    isObject = __webpack_require__(100),
    toKey = __webpack_require__(44482);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 79094:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(79860),
    baseAggregator = __webpack_require__(27957),
    baseIteratee = __webpack_require__(11340),
    isArray = __webpack_require__(35067);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 27150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(55156);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 10145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(35247),
    createAggregator = __webpack_require__(79094);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 21781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(6746),
    getTag = __webpack_require__(26832),
    isArguments = __webpack_require__(19563),
    isArray = __webpack_require__(35067),
    isArrayLike = __webpack_require__(55156),
    isBuffer = __webpack_require__(40206),
    isPrototype = __webpack_require__(2818),
    isTypedArray = __webpack_require__(16402);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 5280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(49157);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 64635:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 60554:
/***/ (function(module) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),

/***/ 5365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11340),
    negate = __webpack_require__(60554),
    pickBy = __webpack_require__(68647);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),

/***/ 68647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(95260),
    baseIteratee = __webpack_require__(11340),
    basePickBy = __webpack_require__(42274),
    getAllKeysIn = __webpack_require__(47516);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),

/***/ 88955:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 87653:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 92583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(88955);
exports.encode = exports.stringify = __webpack_require__(87653);


/***/ }),

/***/ 93706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fB": function() { return /* binding */ BREADCRUMBS_ITEM_TEST_ID; },
  "ZP": function() { return /* binding */ components_Breadcrumbs; }
});

// UNUSED EXPORTS: BreadcrumbsSeparator

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(61978);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/context/CityPageContext.tsx
var CityPageContext = __webpack_require__(72023);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/utils/cities/province-utils.ts
var province_utils = __webpack_require__(59522);
;// CONCATENATED MODULE: ./src/utils/breadcrumbs.ts


function getListingsBreadcrumbs(t, lang, hasProperty, cities, area, city, zone) {
    var isProvince = province_utils/* default.citySupportsProvince */.Z.citySupportsProvince(area === null || area === void 0 ? void 0 : area.name, cities);
    var breadcrumbs = [];
    // Add area
    if (isProvince) {
        var newBreadcrumb = {
            href: linkBuilder/* linkBuilder.listingByArea.url */.H.listingByArea.url(lang, cities, area === null || area === void 0 ? void 0 : area.slug),
            isLast: Boolean(!city && !zone),
            isLink: Boolean(area && city),
            label: t("common:province-of", {
                area: area === null || area === void 0 ? void 0 : area.translatedCityName
            }),
            showOnMobile: Boolean(hasProperty || typeof zone === "undefined")
        };
        breadcrumbs.push(newBreadcrumb);
    }
    // Add city
    if (typeof city !== "undefined") {
        var ref;
        var newBreadcrumb1 = {
            href: linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities, city.slug),
            isLast: Boolean(!zone && !hasProperty),
            isLink: Boolean(zone || hasProperty && ((ref = city.city_zones) === null || ref === void 0 ? void 0 : ref.length) === 0),
            label: city.translatedCityName,
            showOnMobile: Boolean(hasProperty || city || zone)
        };
        breadcrumbs.push(newBreadcrumb1);
    }
    // Add zone if city with zone
    // FIXME why checking for zone not undefined?? is it something legacy that cannot occur anymore?
    if ((zone === null || zone === void 0 ? void 0 : zone.slug) && (zone === null || zone === void 0 ? void 0 : zone.label) && typeof zone !== "undefined") {
        var newBreadcrumb2 = {
            href: linkBuilder/* linkBuilder.listingByZone.url */.H.listingByZone.url(lang, cities, city.slug, zone.slug),
            isLast: !hasProperty,
            isLink: hasProperty,
            label: zone.label,
            showOnMobile: true
        };
        breadcrumbs.push(newBreadcrumb2);
    }
    return breadcrumbs;
}

// EXTERNAL MODULE: ./src/utils/get-translated-title.ts
var get_translated_title = __webpack_require__(22862);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(66731);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/keyboard-helper.ts
var keyboard_helper = __webpack_require__(8123);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/components/Breadcrumbs/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Breadcrumbs/styles.css.ts.vanilla.css","source":"LmtnMWk3cjAgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgZGlzcGxheTogZmxleDsKICBjb2xvcjogdmFyKC0tXzFtdWg4bmtvKTsKfQoua2cxaTdyMSB7CiAgZmxleC1zaHJpbms6IDA7Cn0KLmtnMWk3cjE6aG92ZXIgewogIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lOwp9Ci5rZzFpN3IyIHsKICBib3JkZXItYm90dG9tOiAzcHggc29saWQgdHJhbnNwYXJlbnQ7CiAgYm9yZGVyLWxlZnQ6IDNweCBzb2xpZCB2YXIoLS1fMW11aDhua2wpOwogIGJvcmRlci10b3A6IDNweCBzb2xpZCB0cmFuc3BhcmVudDsKICBoZWlnaHQ6IDA7CiAgbWFyZ2luOiAwIHZhcigtLV8xbXVoOG5rMmEpOwogIHdpZHRoOiAwOwp9Ci5rZzFpN3IzIHsKICBib3JkZXItYm90dG9tOiBub25lOwogIGJvcmRlci1sZWZ0OiAzcHggc29saWQgdHJhbnNwYXJlbnQ7CiAgYm9yZGVyLXJpZ2h0OiAzcHggc29saWQgdHJhbnNwYXJlbnQ7CiAgYm9yZGVyLXRvcDogM3B4IHNvbGlkIHZhcigtLV8xbXVoOG5rbCk7Cn0KLmtnMWk3cjQgewogIGN1cnNvcjogZGVmYXVsdDsKICBmbGV4LXNocmluazogMDsKICB0ZXh0LWRlY29yYXRpb246IG5vbmU7CiAgd2hpdGUtc3BhY2U6IG5vd3JhcDsKfQoua2cxaTdyNSB7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsKICBwYWRkaW5nLXJpZ2h0OiB2YXIoLS1fMW11aDhuazI4KTsKfQoua2cxaTdyNiB7CiAgY3Vyc29yOiBwb2ludGVyOwp9Ci5rZzFpN3I2OmhvdmVyIHsKICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(11127);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
var vanilla_extract_recipes_createRuntimeFn_esm = __webpack_require__(83331);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/styles.css.ts



var breadcrumbsContainer = 'kg1i7r0';
var breadcrumbsFakeLink = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'kg1i7r4',variantClassNames:{isOverflow:{true:'kg1i7r5'},isClickable:{true:'kg1i7r6'}},defaultVariants:{},compoundVariants:[]});
var breadcrumbsLink = 'kg1i7r1';
var breadcrumbsSeparator = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'kg1i7r2',variantClassNames:{rotateDown:{true:'kg1i7r3'}},defaultVariants:{},compoundVariants:[]});
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumb.tsx










/**
 * onClick is used only when isLink = false
 */ var Breadcrumb = function(param) {
    var children = param.children, href = param.href, isLink = param.isLink, isOverflow = param.isOverflow, onClick = param.onClick, _showOnMobile = param.showOnMobile, showOnMobile = _showOnMobile === void 0 ? true : _showOnMobile;
    return isLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()(breadcrumbsLink, (0,sprinkles_css/* sprinkles */.K)({
                display: {
                    desktop: "inline-block",
                    mobile: showOnMobile ? "inline-block" : "none",
                    tablet: "inline-block"
                }
            })),
            "data-testid": BREADCRUMBS_ITEM_TEST_ID,
            onClick: function() {
                return (0,eventsHandlers/* handleListingPageClick */.kN)("Breadcrumb");
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                children: children
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(breadcrumbsFakeLink({
            isClickable: typeof onClick !== "undefined",
            isOverflow: isOverflow
        }), (0,sprinkles_css/* sprinkles */.K)({
            display: {
                desktop: "inline-block",
                mobile: showOnMobile ? "inline-block" : "none",
                tablet: "inline-block"
            }
        })),
        "data-testid": BREADCRUMBS_ITEM_TEST_ID,
        role: "button",
        tabIndex: 0,
        onClick: function() {
            return typeof onClick !== "undefined" && onClick();
        },
        onKeyDown: function(e) {
            return (0,keyboard_helper/* isEnter */.t)(e) && typeof onClick !== "undefined" && onClick();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
            children: children
        })
    });
};
/* harmony default export */ var Breadcrumbs_Breadcrumb = (Breadcrumb);

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.tsx

















var BREADCRUMBS_ITEM_TEST_ID = "breadcrumbs-item";
var Breadcrumbs = function(_param) {
    var cities = _param.cities, isOverflow = _param.isOverflow, property = _param.property, props = (0,_object_without_properties/* default */.Z)(_param, [
        "cities",
        "isOverflow",
        "property"
    ]);
    var ref;
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var handleListingPageBreadcrumbClick = function() {
        return (0,eventsHandlers/* handleListingPageClick */.kN)("Breadcrumb") // TODO: check usage
        ;
    };
    var hasProperty = typeof property !== "undefined";
    var breadcrumbs = getListingsBreadcrumbs(t, lang, hasProperty, cities.list, cities.router.area, cities.router.city, cities.router.zone);
    var openBreadcrumbModal = (0,CityPageContext/* useCityPage */.zh)().openBreadcrumbModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: breadcrumbsContainer
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: classnames_default()(breadcrumbsLink, (0,sprinkles_css/* sprinkles */.K)({
                    display: {
                        desktop: "inline-block",
                        mobile: Boolean(property || !cities.router.city) ? "inline-block" : "none",
                        tablet: "inline-block"
                    }
                })),
                "data-testid": BREADCRUMBS_ITEM_TEST_ID,
                href: linkBuilder/* linkBuilder.housesForSaleCasavoWebsite.url */.H.housesForSaleCasavoWebsite.url(lang),
                onClick: handleListingPageBreadcrumbClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                    children: t("common:footer-our-properties-label")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
                showOnMobile: Boolean(property || !cities.router.city)
            }),
            breadcrumbs.length > 0 && breadcrumbs.map(function(param) {
                var href = param.href, isLast = param.isLast, isLink = param.isLink, label = param.label, showOnMobile = param.showOnMobile;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumb, {
                            href: href,
                            isLink: isLink,
                            showOnMobile: showOnMobile,
                            onClick: !isLink ? openBreadcrumbModal : undefined,
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
                            rotateDown: isLast,
                            showOnMobile: showOnMobile
                        })
                    ]
                }, (0,lodash.kebabCase)(label));
            }),
            property && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumb, {
                "data-testid": BREADCRUMBS_ITEM_TEST_ID,
                isLink: false,
                isOverflow: isOverflow,
                showOnMobile: true,
                children: (0,get_translated_title/* default */.Z)((ref = property.detail) === null || ref === void 0 ? void 0 : ref.titles, lang)
            })
        ]
    }));
};
var BreadcrumbsSeparator = function(param) {
    var rotateDown = param.rotateDown, showOnMobile = param.showOnMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(breadcrumbsSeparator({
            rotateDown: rotateDown
        }), (0,sprinkles_css/* sprinkles */.K)({
            display: {
                desktop: "inline-block",
                mobile: showOnMobile ? "inline-block" : "none",
                tablet: "inline-block"
            }
        }))
    });
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 86284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ MobileBottomContainerFixed; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/components/MobileBottomContainerFixed/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/MobileBottomContainerFixed/styles.css.ts.vanilla.css","source":"Ll8xcW9weTl5MSB7CiAgcG9zaXRpb246IGZpeGVkOwogIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47CiAgYm90dG9tOiB2YXIoLS1fMW11aDhuazFyKTsKICBsZWZ0OiAwOwogIHJpZ2h0OiAwOwogIG1hcmdpbi1ib3R0b206IGVudihzYWZlLWFyZWEtaW5zZXQtYm90dG9tKTsKICBwYWRkaW5nLWxlZnQ6IGVudihzYWZlLWFyZWEtaW5zZXQtbGVmdCk7CiAgcGFkZGluZy1yaWdodDogZW52KHNhZmUtYXJlYS1pbnNldC1yaWdodCk7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(40473);
;// CONCATENATED MODULE: ./src/components/MobileBottomContainerFixed/styles.css.ts



var mobileBottomContainerFixed = '_1qopy9y1 _1b5wm206 tfghjg1u tfghjg1t';
;// CONCATENATED MODULE: ./src/components/MobileBottomContainerFixed/index.tsx


var MobileBottomContainerFixed = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: mobileBottomContainerFixed,
        children: children
    });
};


/***/ }),

/***/ 95839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ MobileBottomMenu; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/SuggestedCriteriaProvider.tsx
var SuggestedCriteriaProvider = __webpack_require__(51701);
// EXTERNAL MODULE: ./src/design-lib/components/Icons/index.tsx + 21 modules
var Icons = __webpack_require__(7984);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/i18n-routes.ts
var i18n_routes = __webpack_require__(31693);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/navigation.ts + 1 modules
var navigation = __webpack_require__(59165);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/components/NotificationCircle/index.tsx + 1 modules
var NotificationCircle = __webpack_require__(70034);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/components/MobileBottomMenu/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/MobileBottomMenu/styles.css.ts.vanilla.css","source":"Ll81NWJvZzcxIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMW11aDhua2cpOwogIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5OwogIGJveC1zaGFkb3c6IDBweCAtMXB4IDFweCByZ2JhKDI5LDI5LDI3LDAuMTUpOwogIGNvbnRhaW46IHBhaW50OwogIHBhZGRpbmctYm90dG9tOiBjYWxjKHZhcigtLV8xbXVoOG5rMmEpICsgdmFyKC0tXzFtdWg4bmsyMykpOwp9Ci5fNTVib2c3MiB7CiAgZmxleC1iYXNpczogNjBweDsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(17789);
;// CONCATENATED MODULE: ./src/components/MobileBottomMenu/styles.css.ts



var mobileBottomMenuWrapper = '_55bog71 tfghjgh9 tfghjgif tfghjg1u tfghjg9f tfghjgk3';
var mobileButton = '_55bog72';
;// CONCATENATED MODULE: ./src/components/MobileBottomMenu/index.tsx


















var MobileBottomMenu = function(param) {
    var activeButton = param.activeButton;
    var user = (0,AuthProvider/* useAuthentication */.JL)().user;
    var hasSuggestedCriteria = (0,SuggestedCriteriaProvider/* useSuggestedCriteria */.l0)().hasSuggestedCriteria;
    var router = (0,next_router.useRouter)();
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var ref1 = (0,react.useState)(""), searchHref = ref1[0], setSearchHref = ref1[1];
    var hasUserSavedSuggestedCriteria = user && hasSuggestedCriteria;
    var handleSuggested = function() {
        if (user) {
            (0,eventsHandlers/* handleClick */.qk)("ActionBar", "Auth", "Suggested");
        } else {
            (0,eventsHandlers/* handleClick */.qk)("ActionBar", "Unauth", "Suggested");
        }
        var path = hasUserSavedSuggestedCriteria ? i18n_routes/* suggestedFeedPath */.jn : i18n_routes/* suggestedOnboardingPath */.FW;
        router.push((0,navigation/* buildRelativeLocalizedLink */.JS)(path, lang));
    };
    var suggestedLabel = hasUserSavedSuggestedCriteria ? t("action-bar:Suggested_Auth_Button") : t("action-bar:Suggested_Unauth_Button");
    (0,react.useEffect)(function() {
        setSearchHref((0,navigation/* getValidReferrerOr */.LQ)(linkBuilder/* linkBuilder.housesForSale.url */.H.housesForSale.url(lang)));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: mobileBottomMenuWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomMenuButton, {
                iconKey: "HouseCheck",
                isActive: activeButton === "suggested",
                label: suggestedLabel,
                showNotification: !hasUserSavedSuggestedCriteria,
                onClick: handleSuggested
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomMenuButton, {
                href: searchHref,
                iconKey: "Magnify",
                isActive: activeButton === "search",
                label: t("action-bar:Search_Button"),
                onClick: function() {
                    return (0,eventsHandlers/* handleUserLoginFlow */.mh)("Click", "SearchButton");
                }
            }),
            user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomMenuButton, {
                href: (0,navigation/* buildRelativeLocalizedLink */.JS)(i18n_routes/* profilePath */.J$, lang),
                iconKey: "Avatar",
                isActive: activeButton === "profile",
                label: t("action-bar:Profile_Button"),
                onClick: function() {
                    return (0,eventsHandlers/* handleUserLoginFlow */.mh)("Click", "ProfileButton");
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomMenuButton, {
                href: (0,navigation/* buildRelativeLocalizedLink */.JS)(i18n_routes/* loginPath */.Qv, lang),
                iconKey: "User",
                isActive: activeButton === "login",
                label: t("action-bar:Login_Button"),
                onClick: function() {
                    return (0,eventsHandlers/* handleUserLoginFlow */.mh)("Click", "LoginButton");
                }
            })
        ]
    });
};
var MobileBottomMenuButton = function(_param) {
    var iconKey = _param.iconKey, isActive = _param.isActive, label = _param.label, showNotification = _param.showNotification, props = (0,_object_without_properties/* default */.Z)(_param, [
        "iconKey",
        "isActive",
        "label",
        "showNotification"
    ]);
    var ButtonIcon = Icons/* default */.Z[iconKey];
    var click = function() {
        var ref;
        (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props);
        if (props.href) {
            window.location.href = props.href;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: classnames_default()(mobileButton, styles_css/* flexColumn */.i3, (0,sprinkles_css/* sprinkles */.K)({
            alignItems: "center",
            flex: 1,
            flexShrink: 0,
            position: "relative"
        })),
        disabled: isActive,
        onClick: click,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon, {
                    color: isActive ? index_es/* colors.orange600 */.O9.orange600 : index_es/* colors.greyscale400 */.O9.greyscale400,
                    height: 20,
                    width: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                color: isActive ? "orange600" : "greyscale400",
                strong: isActive,
                children: label
            }),
            showNotification && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCircle/* NotificationCircle */.v, {
                position: "top"
            })
        ]
    });
};


/***/ }),

/***/ 6067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61978);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7680);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88082);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89847);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44926);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32466);
/* harmony import */ var _context_Cities__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54673);
/* harmony import */ var _utils_breadcrumb_list__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15037);
/* harmony import */ var _utils_getAlternatePageLinks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11755);
/* harmony import */ var _i18n_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31693);













var getTitleAndDescription = function(zone, t, tCity, canonicalFilterId) {
    if (zone) {
        return {
            description: t("zones:seo-description", {
                city: tCity,
                zone: zone.label
            }),
            title: t("zones:seo-title", {
                city: tCity,
                zone: zone.label
            })
        };
    } else if (canonicalFilterId) {
        return {
            description: t("canonical-filters:".concat(canonicalFilterId, ".description"), {
                city: tCity
            }),
            title: t("canonical-filters:".concat(canonicalFilterId, ".title"), {
                city: tCity
            })
        };
    }
    return {
        description: t("common:description-listing", {
            city: tCity
        }),
        title: t("common:title-listing", {
            city: tCity
        })
    };
};
var ListingsMapHead = function(param) {
    var canonicalFilter = param.canonicalFilter, zone = param.zone;
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_4___default()().publicRuntimeConfig;
    var ref = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), lang = ref.lang, t = ref.t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var cities = (0,_context_Cities__WEBPACK_IMPORTED_MODULE_8__/* .useCities */ .M1)();
    var canonicalFilterLabel = canonicalFilter && canonicalFilter.id ? canonicalFilter.id : "";
    // URL path segments
    var housesForSalesSegment = (0,_i18n_routes__WEBPACK_IMPORTED_MODULE_11__/* .getHousesForSalesPathSegment */ .yP)(lang);
    var citySegment = Array.isArray(router.query.city) ? router.query.city[0] : router.query.city;
    var zoneSegment = zone ? zone.slug.split("/")[2] : "";
    var canonicalFilterSegment = canonicalFilterLabel ? canonicalFilter.slug[lang] : "";
    var geoSegment = [
        citySegment,
        zoneSegment,
        canonicalFilterSegment
    ].filter(Boolean).join("/");
    // URL
    var urlPath = "/" + [
        housesForSalesSegment,
        geoSegment
    ].filter(Boolean).join("/") + "/";
    var canonicalUrl = "".concat(publicRuntimeConfig.lisaWebsite).concat(urlPath);
    // Title and Description
    var cityLabel = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.startCase)(citySegment === null || citySegment === void 0 ? void 0 : citySegment.replace(/-/g, " ").toLowerCase());
    var ref1 = getTitleAndDescription(zone, t, cityLabel, canonicalFilterLabel), description = ref1.description, title = ref1.title;
    // Alternate links
    var _query = router.query, city = _query.city, home = _query.home, params = _query.params, queryParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_query, [
        "city",
        "home",
        "params"
    ]);
    var hasQueryParams = Object.keys(queryParams).length > 0;
    var hasCanonicalFilterLabel = canonicalFilterLabel !== "";
    var alternateLinks = null;
    if (!hasQueryParams) {
        if (hasCanonicalFilterLabel) {
            alternateLinks = (0,_utils_getAlternatePageLinks__WEBPACK_IMPORTED_MODULE_10__/* .getAlternatePageLinksWithCanonicalFilter */ .cF)(lang, citySegment, canonicalFilter);
        } else {
            alternateLinks = (0,_utils_getAlternatePageLinks__WEBPACK_IMPORTED_MODULE_10__/* .getAlternatePageLinksWithZone */ .FV)(lang, geoSegment);
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: description,
                        name: "description"
                    }),
                    alternateLinks,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: canonicalUrl,
                        rel: "canonical"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: lang,
                        property: "og:locale"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "article",
                        property: "og:type"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: title,
                        property: "og:title"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: description,
                        property: "og:description"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: canonicalUrl,
                        property: "og:url"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "Casavo",
                        property: "og:site_name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "summary_large_image",
                        name: "twitter:card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: description,
                        name: "twitter:description"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: title,
                        name: "twitter:title"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .BreadcrumbJsonLd */ .gR, {
                itemListElements: (0,_utils_breadcrumb_list__WEBPACK_IMPORTED_MODULE_9__/* .getBreadcrumbList */ .U)({
                    cities: cities.list,
                    city: cities.router.city || cities.router.area,
                    depth: "listings",
                    language: lang,
                    t: t,
                    zone: zone
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListingsMapHead);


/***/ }),

/***/ 46629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ useSaveSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/context/CityPageContext.tsx
var CityPageContext = __webpack_require__(72023);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./src/design-lib/components/Toast/ToastError/index.tsx
var ToastError = __webpack_require__(7929);
// EXTERNAL MODULE: ./src/lib/api-gluglu-auth.ts
var api_gluglu_auth = __webpack_require__(636);
// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Form/createPayload.ts + 1 modules
var createPayload = __webpack_require__(60625);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentDefault.tsx + 7 modules
var ContentDefault = __webpack_require__(6763);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/index.tsx + 1 modules
var ContentLoader = __webpack_require__(46983);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLogin/index.tsx
var ContentLogin = __webpack_require__(28214);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(42493);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/styles.css.ts
var SaveSearch_styles_css = __webpack_require__(70015);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentWrapper.tsx
var ContentWrapper = __webpack_require__(71634);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/GeoInfo.tsx
var GeoInfo = __webpack_require__(27442);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/SearchResults/ContentSuccess.tsx













var ContentSuccess = function(param) {
    var actualZoneFilterAreas = param.actualZoneFilterAreas, isSearchSaved = param.isSearchSaved;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var ref1 = config_default()(), imageBasePath = ref1.publicRuntimeConfig.imageBasePath;
    var cities = (0,Cities/* useCities */.M1)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* ContentWrapper */.v, {
        backToInitialScroll: !isSearchSaved,
        bgColor: "white",
        className: (0,sprinkles_css/* sprinkles */.K)({
            padding: "l"
        }),
        origin: "SEARCH_RESULTS",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: {
                        desktop: "xl",
                        mobile: "l"
                    },
                    marginTop: "l"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "m",
                            textAlign: "center"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            height: 124,
                            src: "".concat(imageBasePath, "/images/concepts/success.svg"),
                            width: 124
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading1 */.nL, {
                        alignment: "center",
                        children: t("save-search:Modal_Success_Title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SaveSearch_styles_css/* saveSearchContent */.GV,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: SaveSearch_styles_css/* saveSearchContentTop */.E8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                    className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                        i18Key: "save-search:Modal_Success_Body1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeoInfo/* GeoInfo */.m, {
                                    activeZones: actualZoneFilterAreas.filter(function(item) {
                                        return item.kind === "zone";
                                    }),
                                    area: (ref2 = (ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.translatedCityName) !== null && ref2 !== void 0 ? ref2 : "".concat(cities.router.area.name, " ").concat(t("common:province"))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                    children: t("save-search:Modal_Success_Body2")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        center: true,
                        className: styles_css/* marginBottom.m */.yl.m,
                        label: t("save-search:Modal_Success_CTA"),
                        minWidth: 160,
                        styleVariant: "secondary",
                        onClick: function() {
                            return closeModal({
                                shouldBackToInitialScroll: isSearchSaved
                            });
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/SearchResults/SaveSearch.tsx




















var SaveSearch = function(param) {
    var actualZoneFilterAreas = param.actualZoneFilterAreas, filters = param.filters, geoSlugs = param.geoSlugs, onSaveSuccess = param.onSaveSuccess;
    var saveSearchButtonState = (0,CityPageContext/* useCityPage */.zh)().saveSearchButtonState;
    var ref = (0,react.useState)(false), isLoadingFavoriteSearch = ref[0], setIsLoadingFavouriteSearch = ref[1];
    var ref1 = (0,react.useState)(false), showContentLogin = ref1[0], setShowContentLogin = ref1[1];
    var ref2 = (0,AuthProvider/* useAuthentication */.JL)(), isLoadingUser = ref2.isLoading, user = ref2.user;
    var ref3 = (0,react.useState)(false), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), showInvalidEmailErrorMessage = ref4[0], setShowInvalidEmailErrorMessage = ref4[1];
    var ref5 = (0,react.useState)(false), showGenericErrorMessage = ref5[0], setShowGenericErrorMessage = ref5[1];
    var device = (0,Device/* useDevice */.Fy)();
    var cities = (0,Cities/* useCities */.M1)();
    var t = (0,useTranslation/* default */.Z)().t;
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var closeBottomSheet = (0,BottomSheetContext/* useBottomSheet */.a)().closeBottomSheet;
    var handleSubmitUserFavoriteSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, favoriteSearchPayload, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        favoriteSearchPayload = (0,createPayload/* createPayload */.Z)({
                            actualZoneFilterAreas: actualZoneFilterAreas,
                            filters: filters,
                            geoSlugs: geoSlugs,
                            origin: "SEARCH_RESULTS",
                            referenceCitySlug: (ref = cities.router.area) === null || ref === void 0 ? void 0 : ref.slug
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsLoadingFavouriteSearch(true);
                        setShowContentLogin(false);
                        closeBottomSheet();
                        return [
                            4,
                            api_gluglu_auth/* default.submitUserFavoriteSearch */.ZP.submitUserFavoriteSearch(favoriteSearchPayload)
                        ];
                    case 2:
                        _state.sent();
                        (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("ActivateAlert", "ListingsFeed");
                        setTimeout(function() {
                            onSaveSuccess();
                        }, ContentLoader/* FORCED_LOADING_TIME */.N);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        (0,eventsHandlers/* handleSystem */.o0)("NewListingsAlert", "ActivateAlertError");
                        if (error.message === "INVALID_EMAIL") {
                            (0,eventsHandlers/* handleShow */.Hf)("AuthError", "InvalidEmail");
                            setShowInvalidEmailErrorMessage(true);
                        } else {
                            (0,eventsHandlers/* handleShow */.Hf)("AuthError", "GenericError");
                            setShowGenericErrorMessage(true);
                        }
                        setError(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTimeout(function() {
                            setIsLoadingFavouriteSearch(false);
                        }, ContentLoader/* FORCED_LOADING_TIME */.N);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitUserFavoriteSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        function run() {
            return _run.apply(this, arguments);
        }
        function _run() {
            _run = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    handleSubmitUserFavoriteSearch();
                    return [
                        2
                    ];
                });
            });
            return _run.apply(this, arguments);
        }
        if (!isLoadingUser && user && (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN")) {
            run().finally(function() {
                sessionStorage.removeItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN");
            });
        }
    }, [
        user,
        isLoadingUser
    ]);
    if (device === "mobile") {
        return saveSearchButtonState === "default" && !isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDefault/* ContentDefault */.I, {
                    actualZoneFilterAreas: actualZoneFilterAreas,
                    cities: cities,
                    filters: filters,
                    geoSlugs: geoSlugs,
                    handleSubmitUserFavoriteSearch: handleSubmitUserFavoriteSearch,
                    origin: "SEARCH_RESULTS",
                    setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch
                }),
                showInvalidEmailErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    description: t("save-search:Error_InvalidMail_Description"),
                    error: error,
                    setError: setError,
                    title: ""
                }),
                showGenericErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    error: error,
                    setError: setError
                })
            ]
        }) : isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoader/* ContentLoader */.p, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSuccess, {
            actualZoneFilterAreas: actualZoneFilterAreas,
            isSearchSaved: saveSearchButtonState !== "default"
        });
    } else {
        return saveSearchButtonState === "default" && !isLoadingFavoriteSearch && !showContentLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDefault/* ContentDefault */.I, {
                    actualZoneFilterAreas: actualZoneFilterAreas,
                    cities: cities,
                    filters: filters,
                    geoSlugs: geoSlugs,
                    handleSubmitUserFavoriteSearch: handleSubmitUserFavoriteSearch,
                    origin: "SEARCH_RESULTS",
                    setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
                    setShowContentLogin: setShowContentLogin
                }),
                showInvalidEmailErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    description: t("save-search:Error_InvalidMail_Description"),
                    error: error,
                    setError: setError,
                    title: t("save-search:Error_InvalidMail_Title")
                }),
                showGenericErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    error: error,
                    setError: setError
                })
            ]
        }) : isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoader/* ContentLoader */.p, {}) : showContentLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLogin/* ContentLogin */.n, {
            actualZoneFilterAreas: actualZoneFilterAreas,
            filters: filters,
            geoSlugs: geoSlugs,
            origin: "SEARCH_RESULTS",
            setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
            onLoggedIn: function() {
                return closeModal();
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSuccess, {
            actualZoneFilterAreas: actualZoneFilterAreas,
            isSearchSaved: saveSearchButtonState !== "default"
        });
    }
};
/* harmony default export */ var SearchResults_SaveSearch = (SaveSearch);

// EXTERNAL MODULE: ./src/design-lib/theme.ts
var theme = __webpack_require__(56161);
;// CONCATENATED MODULE: ./src/hooks/useSaveSearch.tsx









var useSaveSearch = function(param) {
    var appliedGeoFilters = param.appliedGeoFilters, filters = param.filters, geoSlugs = param.geoSlugs;
    var ref = (0,CityPageContext/* useCityPage */.zh)(), buttonState = ref.saveSearchButtonState, setButtonState = ref.setSaveSearchButtonState;
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var ref1 = (0,AuthProvider/* useAuthentication */.JL)(), isUserLoading = ref1.isLoading, user = ref1.user;
    var saveSuccessHandler = function() {
        (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.setItem("CASAVO@LISTINGS-SAVE-SEARCHED", JSON.stringify({
            appliedGeoFilters: appliedGeoFilters,
            filters: filters
        }));
        setButtonState("saved");
    };
    (0,react.useEffect)(function() {
        if ((0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCHED") !== JSON.stringify({
            appliedGeoFilters: appliedGeoFilters,
            filters: filters
        })) {
            setButtonState("default");
        }
    }, [
        filters,
        appliedGeoFilters,
        setButtonState
    ]);
    (0,react.useEffect)(function() {
        if (!isUserLoading && user && (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN")) {
            var saveSearchAfterLoginParams = JSON.parse(sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN"));
            if (saveSearchAfterLoginParams.origin === "SEARCH_RESULTS" && saveSearchAfterLoginParams.pageUrl === window.location.href) {
                openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SaveSearch, {
                    actualZoneFilterAreas: appliedGeoFilters,
                    filters: filters,
                    geoSlugs: geoSlugs,
                    onSaveSuccess: saveSuccessHandler
                }), {
                    background: theme/* theme.colors.offWhite */.r.colors.offWhite,
                    desktopHeight: 670,
                    desktopWidth: 670,
                    overlay: true
                });
            } else {
                sessionStorage.removeItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN");
            }
        }
    }, [
        user,
        isUserLoading
    ]);
    var handleOpenSaveSearchModal = function(e) {
        e.preventDefault();
        (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("ButtonCTA");
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SaveSearch, {
            actualZoneFilterAreas: appliedGeoFilters,
            filters: filters,
            geoSlugs: geoSlugs,
            onSaveSuccess: saveSuccessHandler
        }), {
            background: theme/* theme.colors.offWhite */.r.colors.offWhite,
            desktopHeight: 670,
            desktopWidth: 670,
            overlay: true
        });
    };
    return {
        buttonState: buttonState,
        handleOpenSaveSearchModal: handleOpenSaveSearchModal
    };
};


/***/ }),

/***/ 84127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ ListingsByCityPage; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(63796);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(92583);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(62978);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(5280);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(93072);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(88569);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/use-query-params/esm/index.js + 16 modules
var esm = __webpack_require__(8300);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(97275);
// EXTERNAL MODULE: ./src/components/MobileBottomContainerFixed/index.tsx + 1 modules
var MobileBottomContainerFixed = __webpack_require__(86284);
// EXTERNAL MODULE: ./src/components/MobileBottomMenu/index.tsx + 1 modules
var MobileBottomMenu = __webpack_require__(95839);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(42493);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/_base/SearchInput/index.tsx + 1 modules
var SearchInput = __webpack_require__(26567);
// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/utils/tracking/eventCategory.ts
var eventCategory = __webpack_require__(66576);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Modal/ModalBase/index.tsx + 1 modules
var ModalBase = __webpack_require__(59850);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/utils/cities/province-utils.ts
var province_utils = __webpack_require__(59522);
// EXTERNAL MODULE: ./src/utils/filters-mapper.ts
var filters_mapper = __webpack_require__(31750);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(65594);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(43000);
;// CONCATENATED MODULE: ./src/utils/go-to-page.ts





var goToPage = function(searchParams, router, path, byZone) {
    var queryString = Array.from(searchParams.entries()).reduce(function(acc, item) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, item[0], item[1]));
    }, {});
    var queryStringWithByZone = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
        "byZone"
    ], queryString)), {
        byZone: byZone
    });
    var queryStringWithoutByZone = (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
        "byZone"
    ], queryString));
    router.replace("".concat(path).concat(Object.keys(queryStringWithByZone).length >= 1 && Object.values(queryStringWithByZone).every(Boolean) ? "?".concat(querystring.stringify(queryStringWithByZone)) // TODO: we could use URLSearchParams
     : "?".concat(querystring.stringify(queryStringWithoutByZone))));
};

;// CONCATENATED MODULE: ./src/components/Modal/Types/GeoFilter/apply-geo-filters.tsx





var applyGeoFilters = function(canonicalFilter, cities, geoFiltersParam, lang, router) {
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var url = new URL(router.asPath, publicRuntimeConfig.lisaWebsite);
    url.searchParams.delete("pag");
    if (geoFiltersParam.length === 0) {
        var ref;
        var cityName = cities.router.city ? cities.router.city.name : cities.router.area.name;
        province_utils/* default.citySupportsProvince */.Z.citySupportsProvince(cityName, cities.list) ? goToPage(url.searchParams, router, linkBuilder/* linkBuilder.listingByArea.url */.H.listingByArea.url(lang, cities.list, (ref = cities.router.area) === null || ref === void 0 ? void 0 : ref.slug)) : goToPage(url.searchParams, router, linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities.list, cities.router.city.slug));
    } else if (geoFiltersParam.length === 1 && geoFiltersParam[0].kind === "city") {
        var ref1;
        var filter = geoFiltersParam[0];
        goToPage(url.searchParams, router, linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities.list, (ref1 = cities.list.find(function(c) {
            return c.slug === filter.slug;
        })) === null || ref1 === void 0 ? void 0 : ref1.slug));
    } else {
        // Build query parameters
        var byZone = filters_mapper/* default.buildZoneFilter */.Z.buildZoneFilter(geoFiltersParam);
        /**
     * Go to area page when there are at least 2 city filters or at least a city and a zone
     * For cities like ROME and VERONA go to city page
     */ if (geoFiltersParam.some(function(filter) {
            return filter.kind === "city";
        })) {
            goToPage(url.searchParams, router, linkBuilder/* linkBuilder.listingByArea.url */.H.listingByArea.url(lang, cities.list, cities.router.area.referenceArea), byZone.byZone);
        } else {
            var ref2;
            /**
       * When there will be zones from different cities,
       * we should handle it.
       * Currently we are only handling zones from one city
       */ goToPage(url.searchParams, router, linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities.list, (ref2 = cities.list.find(function(c) {
                return c.city_zones.some(function(z) {
                    return z.slug === geoFiltersParam[0].slug;
                });
            })) === null || ref2 === void 0 ? void 0 : ref2.slug, canonicalFilter && canonicalFilter.slug[lang]), byZone.byZone);
        }
    }
};

// EXTERNAL MODULE: ./src/components/Modal/Types/GeoFilter/Body.tsx + 2 modules
var Body = __webpack_require__(19294);
// EXTERNAL MODULE: ./src/components/Modal/Types/GeoFilter/styles.css.tsx
var styles_css = __webpack_require__(46370);
;// CONCATENATED MODULE: ./src/components/Modal/Types/GeoFilter/Footer.tsx





var Footer = function(props) {
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: styles_css/* geoFilterModalFooter */.uH,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
            "data-testid": "zone-filter-submit",
            label: t("zones:search"),
            minWidth: 225,
            styleVariant: "secondary",
            onClick: props.onSubmit
        })
    });
};
/* harmony default export */ var GeoFilter_Footer = (Footer);

;// CONCATENATED MODULE: ./src/components/Modal/Types/GeoFilter/index.tsx
















var GeoFilterModal = function(param) {
    var _initialFilters = param.initialFilters, initialFilters = _initialFilters === void 0 ? [] : _initialFilters, canonicalFilter = param.canonicalFilter, listingCountByZone = param.listingCountByZone;
    var cities = (0,Cities/* useCities */.M1)();
    var ref = (0,react.useState)(initialFilters), activeFilters = ref[0], setActiveFilters = ref[1];
    var ref1 = (0,react.useState)(""), searchString = ref1[0], setSearchString = ref1[1];
    var t = (0,useTranslation/* default */.Z)().t;
    var lang = (0,useTranslation/* default */.Z)().lang;
    var router = (0,next_router.useRouter)();
    var ref2 = config_default()(), casavoUiCdn = ref2.publicRuntimeConfig.casavoUiCdn;
    var applyFilters = function() {
        (0,eventsHandlers/* handleListingsFilterArea */.Se)("Submit", "SearchArea");
        applyGeoFilters(canonicalFilter, cities, activeFilters, lang, router);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBase/* ModalBase */.e, {
        handleClose: function() {
            return (0,eventsHandlers/* handleListingsFilterArea */.Se)("Click", "Close");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flexShrink: 0
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                alignItems: {
                                    desktop: "flex-end",
                                    mobile: "center"
                                },
                                display: "flex",
                                gap: "s-m"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    height: 36,
                                    src: "".concat(casavoUiCdn, "/illustrations/cities/").concat(cities.router.area.country, "/").concat(cities.router.area.name.toLowerCase(), "-small.svg"),
                                    width: 36
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading3 */.aC, {
                                    children: t("common:where-looking-for")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "l",
                            marginTop: "l"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* SearchInput */.M, {
                            dataTestId: "geofilters-search-input",
                            placeholder: t("zones:search-filters"),
                            value: searchString,
                            onBlur: function(value) {
                                return (0,eventsHandlers/* handleFormFieldSet */.qK)("ListingsFilterArea", "SearchBox", value);
                            },
                            onChange: setSearchString
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                activeFilters: activeFilters,
                eventCategory: eventCategory/* GTMEventCategory.GeoFilterModalInCityPage */.z.GeoFilterModalInCityPage,
                listingCountByZone: listingCountByZone,
                search: searchString,
                setActiveFilters: setActiveFilters,
                setSearch: setSearchString
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeoFilter_Footer, {
                activeFilters: activeFilters,
                onSubmit: applyFilters
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/CityPageContext.tsx
var CityPageContext = __webpack_require__(72023);
// EXTERNAL MODULE: ./src/utils/get-scrollbar-width.ts
var get_scrollbar_width = __webpack_require__(2018);
// EXTERNAL MODULE: ./src/utils/prevent-page-scroll-on-modal-open.ts
var prevent_page_scroll_on_modal_open = __webpack_require__(34958);
// EXTERNAL MODULE: src/components/PrerenderedModal/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/PrerenderedModal/styles.css.ts.vanilla.css","source":"Ll81OWRoZmQwIHsKICBiYWNrZ3JvdW5kOiByZ2JhKDAsIDAsIDAsIC41KTsKICBoZWlnaHQ6IDEwMCU7CiAgbGVmdDogMDsKICBvcGFjaXR5OiAwOwogIHBvc2l0aW9uOiBmaXhlZDsKICB0b3A6IDA7CiAgdHJhbnNpdGlvbjogb3BhY2l0eSAzMDBtcyBlYXNlLCB2aXNpYmlsaXR5IDMwMG1zIGVhc2U7CiAgdmlzaWJpbGl0eTogaGlkZGVuOwogIHdpZHRoOiAxMDB2dzsKICB6LWluZGV4OiA5OTk5Owp9Ci5fNTlkaGZkMiB7CiAgb3BhY2l0eTogMTsKICB2aXNpYmlsaXR5OiB2aXNpYmxlOwp9Ci5fNTlkaGZkMyB7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRkZGRjsKICBoZWlnaHQ6IDEwMCU7CiAgbGVmdDogMDsKICBwb3NpdGlvbjogcmVsYXRpdmU7CiAgdG9wOiAwOwogIHdpZHRoOiAxMDAlOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl81OWRoZmQzIHsKICAgIGJvcmRlci1yYWRpdXM6IDRweDsKICAgIGhlaWdodDogNTgwcHg7CiAgICBsZWZ0OiA1MCU7CiAgICB0b3A6IDUwJTsKICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpOwogICAgd2lkdGg6IDY0MHB4OwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(98026);
;// CONCATENATED MODULE: ./src/components/PrerenderedModal/styles.css.ts

var prerenderedModalInner = '_59dhfd3';
var prerenderedModalOuter = {'default':'_59dhfd0',breadcrumbModalOpen:'_59dhfd2 _59dhfd0'};
;// CONCATENATED MODULE: ./src/components/PrerenderedModal/index.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ 





var PrerenderedModal = function(props) {
    var overlayRef = (0,react.useRef)(null);
    var ref = (0,CityPageContext/* useCityPage */.zh)(), closeBreadcrumbModal = ref.closeBreadcrumbModal, isBreadcrumbModalOpen = ref.isBreadcrumbModalOpen;
    (0,react.useEffect)(function() {
        if (isBreadcrumbModalOpen) {
            var scrollbarWidth = (0,get_scrollbar_width/* getScrollbarWidth */.n)();
            overlayRef.current.focus();
            (0,prevent_page_scroll_on_modal_open/* addPositionFixedToBody */.bG)(scrollbarWidth);
        } else {
            (0,prevent_page_scroll_on_modal_open/* backToTopOnModalClose */.q0)();
        }
    }, [
        isBreadcrumbModalOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: overlayRef,
        className: isBreadcrumbModalOpen ? prerenderedModalOuter.breadcrumbModalOpen : prerenderedModalOuter["default"],
        "data-testid": "PrerenderedModalOverlay",
        role: "button",
        tabIndex: 0,
        onClick: function(e) {
            if (e.target === overlayRef.current) {
                closeBreadcrumbModal();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: prerenderedModalInner,
            children: props.children
        })
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(61978);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(66731);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Breadcrumbs/index.tsx + 3 modules
var Breadcrumbs = __webpack_require__(93706);
// EXTERNAL MODULE: ./src/design-lib/components/Icons/Close/index.tsx
var Close = __webpack_require__(31459);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var shared_styles_styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/navigation.ts + 1 modules
var navigation = __webpack_require__(59165);
// EXTERNAL MODULE: src/components/PrerenderedModal/Types/BreadcrumbModal/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/PrerenderedModal/Types/BreadcrumbModal/styles.css.ts.vanilla.css","source":"Ll84dnBvM3cwIHsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47CiAgaGVpZ2h0OiAxMDAlOwp9Ci5fOHZwbzN3MSB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBkaXNwbGF5OiBmbGV4OwogIGhlaWdodDogNzhweDsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47CiAgcGFkZGluZzogMjRweDsKfQouXzh2cG8zdzIgewogIGZsZXgtYmFzaXM6IGF1dG87CiAgZmxleC1ncm93OiAxOwogIG92ZXJmbG93LXk6IGF1dG87Cn0KLl84dnBvM3czIHsKICBkaXNwbGF5OiBibG9jazsKICBwYWRkaW5nLWJvdHRvbTogMTZweDsKICBwYWRkaW5nLWxlZnQ6IDI0cHg7CiAgcGFkZGluZy1yaWdodDogMjRweDsKICBwYWRkaW5nLXRvcDogMTZweDsKfQouXzh2cG8zdzM6aG92ZXIgewogIGJhY2tncm91bmQtY29sb3I6ICNGNUY1RjU7Cn0KLl84dnBvM3c1IHsKICBjb2xvcjogIzFEMUQxQjsKICBmb250LXdlaWdodDogYm9sZDsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fOHZwbzN3MCB7CiAgICBtYXgtaGVpZ2h0OiA1ODBweDsKICB9Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(64849);
;// CONCATENATED MODULE: ./src/components/PrerenderedModal/Types/BreadcrumbModal/styles.css.ts

var breadcrumbLink = {'default':'_8vpo3w3',selected:'_8vpo3w5 _8vpo3w3'};
var breadcrumbModalHeader = '_8vpo3w1';
var breadcrumbModalInner = '_8vpo3w2';
var breadcrumbModalOuter = '_8vpo3w0';
;// CONCATENATED MODULE: ./src/components/PrerenderedModal/Types/BreadcrumbModal/index.tsx
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 



















var LIST_ITEM_TEST_ID = "breadcrumb-modal-list-item";
var BreadcrumbModal = function() {
    var makeHref = /**
   * Retrieve correct href based on item type
   */ function makeHref(item) {
        switch(item.kind){
            case "area":
                return linkBuilder/* linkBuilder.listingByArea.url */.H.listingByArea.url(lang, cities.list, item.slug);
            case "city":
                return linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities.list, item.slug);
            case "zone":
                return linkBuilder/* linkBuilder.listingByZone.url */.H.listingByZone.url(lang, cities.list, item.cityValue, item.slug);
        }
    };
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var cities = (0,Cities/* useCities */.M1)();
    var router = (0,next_router.useRouter)();
    var currentCity = cities.router.city || cities.router.area;
    var areaItem = {
        cityValue: cities.router.area.name,
        kind: "area",
        label: "".concat(t("common:province-of", {
            area: cities.router.area.translatedCityName
        })),
        slug: cities.router.area.slug
    };
    var mapCity = (0,fp.map)(function(city) {
        return {
            cityValue: city.name,
            kind: "city",
            label: city.translatedCityName,
            slug: city.slug
        };
    });
    var mapZone = (0,fp.map)(function(zone) {
        return {
            cityValue: cities.router.city.slug,
            kind: "zone",
            label: zone.label,
            slug: zone.slug
        };
    });
    var sortActiveZone = function(zones) {
        return (0,_to_consumable_array/* default */.Z)(zones).sort(function(a, b) {
            var ref, ref1, ref2, ref3;
            if (b.slug === ((ref = cities.router) === null || ref === void 0 ? void 0 : (ref1 = ref.zone) === null || ref1 === void 0 ? void 0 : ref1.slug)) {
                return 1;
            } else if (a.slug === ((ref2 = cities.router) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.zone) === null || ref3 === void 0 ? void 0 : ref3.slug)) {
                return -1;
            }
            return 0;
        });
    };
    var sortByLabel = (0,fp.sortBy)("label");
    var makeZones = (0,fp.pipe)(mapZone, sortByLabel, sortActiveZone);
    var makeCities = (0,fp.pipe)(mapCity, sortByLabel);
    var closeBreadcrumbModal = (0,CityPageContext/* useCityPage */.zh)().closeBreadcrumbModal;
    /**
   * Creates items for the modal
   */ var items = function() {
        var toReturn = [];
        if (province_utils/* default.citySupportsProvince */.Z.citySupportsProvince(cities.router.area.name, cities.list)) toReturn.push([
            areaItem
        ]);
        if (typeof cities.router.city !== "undefined") {
            toReturn.push(makeCities([
                cities.router.city
            ]));
            if (cities.router.city.city_zones.length > 0) toReturn.push(makeZones(cities.router.city.city_zones));
        } else {
            toReturn.push(makeCities(cities.list));
        }
        return toReturn;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: breadcrumbModalOuter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: breadcrumbModalHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    ariaLabel: "Close",
                    className: shared_styles_styles_css/* marginLeft.auto */.oI.auto,
                    "data-testid": "close-breadcrumb-modal-button",
                    Icon: function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                    },
                    shapeVariant: "round",
                    styleVariant: "tertiary",
                    onClick: function() {
                        closeBreadcrumbModal();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingX: "l",
                    paddingY: "m"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.ZP, {
                    cities: cities
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: breadcrumbModalInner,
                children: items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: items.map(function(section, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                section.map(function(item) {
                                    var href = makeHref(item);
                                    var isSelected = (0,navigation/* buildRelativeLocalizedLink */.JS)(router.asPath, lang) === href;
                                    var onElementClick = function() {
                                        return closeBreadcrumbModal("selectedItem", "".concat(currentCity.name, " - ").concat(item.label));
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: onElementClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: isSelected ? breadcrumbLink.selected : breadcrumbLink["default"],
                                                "data-testid": "".concat(LIST_ITEM_TEST_ID, "-").concat(item.label.toLowerCase().replace(/\s+/g, "-")),
                                                children: item.label
                                            })
                                        })
                                    }, "".concat(item.slug, "-").concat((0,lodash.kebabCase)(item.label)));
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                            ]
                        }, "section-".concat(index));
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/cities-mapper.ts
var cities_mapper = __webpack_require__(1966);
// EXTERNAL MODULE: ./src/types/graphql-generated-types.ts
var graphql_generated_types = __webpack_require__(98733);
// EXTERNAL MODULE: ./src/utils/listing-facilities.ts
var listing_facilities = __webpack_require__(55600);
// EXTERNAL MODULE: ./src/utils/locale-variables/index.ts
var locale_variables = __webpack_require__(98640);
;// CONCATENATED MODULE: ./src/utils/get-page-type-from-params.ts




// TODO: Avoid having to specify slug for locales that do not support the canonical filter
var canonicalFilters = [
    {
        filter: {
            onlyWithTerrace: true
        },
        id: "terrace",
        slug: {
            en: "terrace",
            fr: "",
            it: "terrazzo"
        }
    },
    {
        filter: {
            onlyWithBalcony: true
        },
        id: "balcony",
        slug: {
            en: "balcony",
            fr: "",
            it: "balcone"
        }
    },
    {
        filter: {
            byRooms: {
                from: 1,
                to: 1
            }
        },
        id: "studios",
        slug: {
            en: "studios",
            fr: "",
            it: "monolocali"
        }
    },
    {
        filter: {
            byRooms: {
                from: 2,
                to: 2
            }
        },
        id: "one-bedroom-apartments",
        slug: {
            en: "one-bedroom-apartments",
            fr: "",
            it: "bilocali"
        }
    },
    {
        filter: {
            byRooms: {
                from: 3,
                to: 3
            }
        },
        id: "two-bedroom-apartments",
        slug: {
            en: "two-bedroom-apartments",
            fr: "",
            it: "trilocali"
        }
    },
    {
        filter: {
            byStateOfMaintenance: [
                graphql_generated_types/* StateOfMaintenanceFilter.New */.af.New
            ]
        },
        id: "new-constructions",
        slug: {
            en: "new-constructions",
            fr: "",
            it: "nuove-costruzioni"
        }
    }, 
];
var isFilteredPage = function(locale, queryParams) {
    return (0,locale_variables/* isLocaleEnabledFor */.vw)("filteredPages", locale) && queryParams.length === 1 && canonicalFilters.some(function(cF) {
        return queryParams[0] === cF.slug[locale];
    });
};
var isZonePage = function(city, queryParams, cities) {
    var currentCity = findCity(city, cities);
    var currentZone = currentCity && citiesMapper.findZone(queryParams[0], currentCity.city_zones) // validate zone over the current city
    ;
    return queryParams.length === 1 && !!(currentZone === null || currentZone === void 0 ? void 0 : currentZone.slug);
};
var isDetailPage = function(locale, city, currentZone, queryParams) {
    var isOnCityWithoutZone = queryParams.length === 1 && currentZone === undefined && !isFilteredPage(locale, queryParams);
    var isOnCityWithZone = queryParams.length === 2 && currentZone !== undefined && currentZone.slug !== undefined;
    var isNotOnValidCity = !listingFacilities.validateCity(city, locale);
    return isOnCityWithoutZone || isOnCityWithZone || isNotOnValidCity;
};
var getPageTypeFromParams = function(locale, city, currentZone, queryParams, cities) {
    var isOnFilteredPage = isFilteredPage(locale, queryParams);
    var isOnZonePage = isZonePage(city, queryParams, cities);
    var isOnDetailPage = isDetailPage(locale, city, currentZone, queryParams);
    var isCityValid = findCity(city, cities);
    if (!isCityValid || !(isOnFilteredPage || isOnZonePage || isOnDetailPage)) {
        return "not-found";
    }
    if (isOnFilteredPage) {
        return "canonical-filter";
    }
    if (isOnZonePage) {
        return "zone";
    }
    if (isOnDetailPage) {
        return "detail";
    }
    return "not-found";
};
var __test = {
    isFilteredPage: isFilteredPage
};

;// CONCATENATED MODULE: ./src/components/PrerenderedSeoLinks/mostVisitedZonesSlug.ts
var mostVisitedZonesSlug = {
    BOLOGNA: [
        "it/bologna/san-donato-pilastro",
        "it/bologna/murri-massarenti",
        "it/bologna/toscana-savena",
        "it/bologna/san-vitale-mazzini",
        "it/bologna/costa-saragozza-saffi", 
    ],
    FLORENCE: [
        "it/firenze/centro",
        "it/firenze/campo-di-marte-liberta",
        "it/firenze/coverciano-bellariva",
        "it/firenze/oltrarno",
        "it/firenze/michelangelo-porta-romana", 
    ],
    MILAN: [
        "it/milano/centro",
        "it/milano/fiera-sempione-city-life-portello",
        "it/milano/porta-romana-cadore-montenero",
        "it/milano/citta-studi-susa",
        "it/milano/porta-venezia-indipendenza", 
    ],
    ROME: [
        "it/roma/salario-trieste",
        "it/roma/prati-borgo-mazzini-delle-vittorie",
        "it/roma/parioli-flaminio",
        "it/roma/centro-storico",
        "it/roma/bologna-policlinico", 
    ],
    TURIN: [
        "it/torino/centro",
        "it/torino/crocetta-san-secondo",
        "it/torino/campidoglio-san-donato-cit-turin",
        "it/torino/borgo-san-paolo-cenisia",
        "it/torino/santa-rita-mirafiori-nord", 
    ],
    VERONA: [
        "it/verona/borgo-nuovo-navigatori-ponte-crencano",
        "it/verona/borgo-roma-ca-di-david",
        "it/verona/borgo-venezia-santa-croce-porto-san-pancrazio",
        "it/verona/borgo-milano-stadio-san-massimo-croce-bianca",
        "it/verona/centro", 
    ]
};
/* harmony default export */ var PrerenderedSeoLinks_mostVisitedZonesSlug = (mostVisitedZonesSlug);

;// CONCATENATED MODULE: ./src/components/PrerenderedSeoLinks/index.tsx










var PrerenderedSeoLinks = function(param) {
    var canonicalFilter = param.canonicalFilter, isLoading = param.isLoading;
    var ref;
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var cities = (0,Cities/* useCities */.M1)();
    var currentCity = cities.router.city || cities.router.area;
    var isCurrentZone = function(zone) {
        var ref;
        return zone.slug === ((ref = cities.router.zone) === null || ref === void 0 ? void 0 : ref.slug);
    };
    var mostVisitedZonesSlugForCity = PrerenderedSeoLinks_mostVisitedZonesSlug[currentCity.name.toUpperCase()] || [];
    var zones = (ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.city_zones.filter(function(zone) {
        return mostVisitedZonesSlugForCity.includes(zone.slug) && !isCurrentZone(zone);
    }).sort(function(z1, z2) {
        return mostVisitedZonesSlugForCity.indexOf(z1.slug) - mostVisitedZonesSlugForCity.indexOf(z2.slug);
    });
    var showPrerenderedSeoLinks = (0,cities_mapper/* isCityReferenceArea */.V1)(cities.router.city) || (zones === null || zones === void 0 ? void 0 : zones.length) > 0;
    if (!showPrerenderedSeoLinks) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: isLoading ? "none" : "block",
            marginTop: "4xl"
        }),
        children: [
            (0,cities_mapper/* isCityReferenceArea */.V1)(cities.router.city) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        strong: true,
                        as: "h3",
                        children: t("common:listings.canonical-links-title", {
                            city: cities.router.city.translatedCityName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        children: canonicalFilters.filter(function(cF) {
                            return cF.id !== (canonicalFilter === null || canonicalFilter === void 0 ? void 0 : canonicalFilter.id);
                        }).map(function(canonicalFilter) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "inline-block",
                                    marginRight: "s",
                                    paddingBottom: "xs"
                                }),
                                href: "".concat(linkBuilder/* linkBuilder.listingByCity.url */.H.listingByCity.url(lang, cities.list, currentCity.slug)).concat(canonicalFilter.slug[lang], "/"),
                                onClick: function() {
                                    return (0,eventsHandlers/* handleListingsCanonicalFiltersClick */.pv)(canonicalFilter.id);
                                },
                                children: t("canonical-filters:".concat(canonicalFilter.id, ".label"))
                            }, canonicalFilter.id);
                        })
                    })
                ]
            }),
            (zones === null || zones === void 0 ? void 0 : zones.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingTop: "l"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        strong: true,
                        as: "h3",
                        children: t("common:listings.most-visited-zones-title", {
                            city: cities.router.city.translatedCityName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        children: zones.map(function(zone, idx, arr) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "inline-block",
                                    marginRight: "xs",
                                    paddingBottom: "xs"
                                }),
                                href: linkBuilder/* linkBuilder.listingByZone.url */.H.listingByZone.url(lang, cities.list, currentCity.slug, zone.slug),
                                onClick: function() {
                                    return (0,eventsHandlers/* handleListingsCanonicalZonesClick */.TE)(zone.slug);
                                },
                                children: [
                                    zone.label,
                                    " ",
                                    idx !== arr.length - 1 ? "|" : ""
                                ]
                            }, zone.slug);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PrerenderedSeoLinks = (PrerenderedSeoLinks);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 97 modules
var motion = __webpack_require__(38494);
// EXTERNAL MODULE: ./src/design-lib/components/Callout/Callout.tsx + 1 modules
var Callout = __webpack_require__(77653);
// EXTERNAL MODULE: ./src/hooks/useSaveSearch.tsx + 2 modules
var useSaveSearch = __webpack_require__(46629);
// EXTERNAL MODULE: ./src/components/framer-motion-variants.tsx
var framer_motion_variants = __webpack_require__(20635);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/components/SaveSearchFloatingBanner/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/SaveSearchFloatingBanner/styles.css.ts.vanilla.css","source":"Ll8xMDYzY2J6MSB7CiAgcG9zaXRpb246IGZpeGVkOwp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(85979);
;// CONCATENATED MODULE: ./src/components/SaveSearchFloatingBanner/styles.css.ts


var floatingBannerPosition = '_1063cbz1 tfghjg4x tfghjg5x tfghjg3l tfghjgbl';
;// CONCATENATED MODULE: ./src/components/SaveSearchFloatingBanner/index.tsx








var SaveSearchFloatingBanner = function(param) {
    var appliedGeoFilters = param.appliedGeoFilters, filters = param.filters, geoSlugs = param.geoSlugs, hasOnlyOneListing = param.hasOnlyOneListing;
    var ref = (0,CityPageContext/* useCityPage */.zh)(), hasJustAppliedFilters = ref.filters.hasJustAppliedFilters;
    var handleOpenSaveSearchModal = (0,useSaveSearch/* useSaveSearch */.s)({
        appliedGeoFilters: appliedGeoFilters,
        filters: filters,
        geoSlugs: geoSlugs
    }).handleOpenSaveSearchModal;
    var t = (0,useTranslation/* default */.Z)().t;
    var getText = function() {
        if (hasJustAppliedFilters) {
            return "save-search:saveSearch-floatingBanner-textNewFilters";
        }
        if (hasOnlyOneListing) {
            return "save-search:saveSearch-floatingBanner-text1result";
        }
        return "save-search:saveSearch-floatingBanner-text";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        animate: "animate",
        className: floatingBannerPosition,
        exit: "exit",
        initial: "initial",
        variants: (0,framer_motion_variants/* bottomUpAnimation */.Sw)(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Callout/* Callout */.U, {
            ctaLabel: t("save-search:cta"),
            description: getText(),
            handleClick: handleOpenSaveSearchModal,
            icon: "Bell",
            iconColor: "orange600"
        })
    });
};
/* harmony default export */ var components_SaveSearchFloatingBanner = (SaveSearchFloatingBanner);

// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./src/hooks/usePageYOffset.ts
var usePageYOffset = __webpack_require__(29961);
// EXTERNAL MODULE: ./src/hooks/useTagManager.ts
var useTagManager = __webpack_require__(31551);
// EXTERNAL MODULE: ./src/page-commons/listingsByFilter/helpers.ts
var helpers = __webpack_require__(88108);
// EXTERNAL MODULE: ./src/types/sort.ts
var types_sort = __webpack_require__(73534);
// EXTERNAL MODULE: ./src/utils/nika/listing-mapper.ts + 1 modules
var listing_mapper = __webpack_require__(69631);
;// CONCATENATED MODULE: ./src/utils/sanitize-null.ts
function sanitizeNull(obj) {
    return JSON.parse(JSON.stringify(obj, function(_, value) {
        return value === null ? undefined : value;
    }));
}


// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var _vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/page-commons/ListingsByCityPage/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/page-commons/ListingsByCityPage/styles.css.ts.vanilla.css","source":"Ll8xaG9uOHI5MCB7CiAgbWluLWhlaWdodDogMTAwdmg7Cn0KLl8xaG9uOHI5MSB7CiAgcGFkZGluZy1sZWZ0OiB2YXIoLS1fMW11aDhuazI4KTsKICBwYWRkaW5nLXJpZ2h0OiB2YXIoLS1fMW11aDhuazI4KTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMW11aDhuazE4KTsKICBtYXJnaW4tYm90dG9tOiB2YXIoLS1fMW11aDhuazI4KTsKICBwYWRkaW5nLXRvcDogdmFyKC0tXzFtdWg4bmsyOCk7CiAgcGFkZGluZy1ib3R0b206IGNhbGModmFyKC0tXzFtdWg4bmsyNCkgKyBlbnYoc2FmZS1hcmVhLWluc2V0LWJvdHRvbSkgKyB2YXIoLS1fMW11aDhuazI3KSk7Cn0KQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xaG9uOHI5MCB7CiAgICBkaXNwbGF5OiBmbGV4OwogICAgZmxleC1kaXJlY3Rpb246IHJvdzsKICAgIG1hcmdpbjogMCBhdXRvOwogIH0KICAuXzFob244cjkxIHsKICAgIGFuaW1hdGlvbjogdW5zZXQ7CiAgICBiYWNrZmFjZS12aXNpYmlsaXR5OiBoaWRkZW47CiAgICBtYXJnaW4tYm90dG9tOiAwOwogICAgbWFyZ2luLXRvcDogMDsKICAgIG1pbi13aWR0aDogMDsKICAgIHBhZGRpbmctYm90dG9tOiAwOwogICAgcGFkZGluZy1sZWZ0OiB2YXIoLS1fMW11aDhuazI3KTsKICAgIHBhZGRpbmctcmlnaHQ6IHZhcigtLV8xbXVoOG5rMjcpOwogICAgZmxleC1iYXNpczogODIwcHg7CiAgICBmbGV4LWdyb3c6IDA7CiAgICBmbGV4LXNocmluazogMDsKICB9Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8xaG9uOHI5MCB7CiAgbWluLWhlaWdodDogMTAwdmg7Cn0KLl8xaG9uOHI5MSB7CiAgcGFkZGluZy1sZWZ0OiB2YXIoLS1fMW11aDhuazI4KTsKICBwYWRkaW5nLXJpZ2h0OiB2YXIoLS1fMW11aDhuazI4KTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMW11aDhuazE4KTsKICBtYXJnaW4tYm90dG9tOiB2YXIoLS1fMW11aDhuazI4KTsKICBwYWRkaW5nLXRvcDogdmFyKC0tXzFtdWg4bmsyOCk7CiAgcGFkZGluZy1ib3R0b206IGNhbGModmFyKC0tXzFtdWg4bmsyNCkgKyBlbnYoc2FmZS1hcmVhLWluc2V0LWJvdHRvbSkgKyB2YXIoLS1fMW11aDhuazI3KSk7Cn0KQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xaG9uOHI5MCB7CiAgICBkaXNwbGF5OiBmbGV4OwogICAgZmxleC1kaXJlY3Rpb246IHJvdzsKICAgIG1hcmdpbjogMCBhdXRvOwogIH0KICAuXzFob244cjkxIHsKICAgIGFuaW1hdGlvbjogdW5zZXQ7CiAgICBiYWNrZmFjZS12aXNpYmlsaXR5OiBoaWRkZW47CiAgICBtYXJnaW4tYm90dG9tOiAwOwogICAgbWFyZ2luLXRvcDogMDsKICAgIG1pbi13aWR0aDogMDsKICAgIHBhZGRpbmctYm90dG9tOiAwOwogICAgcGFkZGluZy1sZWZ0OiB2YXIoLS1fMW11aDhuazI3KTsKICAgIHBhZGRpbmctcmlnaHQ6IHZhcigtLV8xbXVoOG5rMjcpOwogICAgZmxleC1iYXNpczogODIwcHg7CiAgICBmbGV4LWdyb3c6IDA7CiAgICBmbGV4LXNocmluazogMDsKICB9Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(82534);
;// CONCATENATED MODULE: ./src/page-commons/ListingsByCityPage/styles.css.ts


var cityPageWrapper = '_1hon8r90';
var contentPanel = '_1hon8r91';
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(82783);
// EXTERNAL MODULE: ./src/api/api-nika.ts
var api_nika = __webpack_require__(14164);
// EXTERNAL MODULE: ./src/graphql/cate/client.ts
var client = __webpack_require__(25852);
// EXTERNAL MODULE: ./src/utils/nika/query-mapper.ts
var query_mapper = __webpack_require__(49487);
// EXTERNAL MODULE: ./src/page-commons/ListingsByCityPage/utils.ts
var utils = __webpack_require__(86099);
;// CONCATENATED MODULE: ./src/page-commons/ListingsByCityPage/useListings.ts









function buildQueryKeyForIndex(name, sort_by, filters, pagination, paginationPriority) {
    return [
        name,
        "".concat(sort_by.by, "-").concat(sort_by.direction),
        pagination ? pagination.page_size : "20",
        pagination ? pagination.page : "1",
        paginationPriority ? paginationPriority.page_size : "20",
        paginationPriority ? paginationPriority.page : "1",
        filters ? JSON.stringify(filters) : "{}", 
    ];
}
var useListings = function(sortBy, filters, pagination, paginationPriority, options) {
    var key = buildQueryKeyForIndex("listingPriority-index", sortBy, filters, pagination, paginationPriority);
    return (0,es.useQuery)(key, function() {
        return Promise.all([
            (0,api_nika/* reqListings */.xL)((0,query_mapper/* legacyFiltersToNikaFilters */.y2)(filters), pagination, (0,query_mapper/* legacySortingToNikaSorting */.k)(sortBy)),
            fetchPriorities(filters, sortBy, paginationPriority, helpers/* PAGINATION_SIZE */.hU), 
        ]).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), resListing = _param[0], potential_property = _param[1];
            return {
                listings: resListing.data,
                priorities: potential_property === null || potential_property === void 0 ? void 0 : potential_property.data
            };
        }).catch();
    }, options);
};
var fetchPriorities = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(filters, sort, param, limit) {
        var page, page_size, offset;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = param.page, page_size = param.page_size;
                    offset = page === 1 ? 0 : (page - 1) * page_size;
                    return [
                        4,
                        client/* default.potentialPropertyByFilter */.Z.potentialPropertyByFilter({
                            limit: limit,
                            offset: offset,
                            orderBy: (0,utils/* getPriorityGroupBy */.ys)(sort),
                            where: (0,utils/* getPriorityWhereCondition */.lT)(filters)
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchPriorities(filters, sort, _, limit) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/page-commons/ListingsByCityPage/index.tsx






































var ListingContent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9421), __webpack_require__.e(1572), __webpack_require__.e(2752), __webpack_require__.e(5736), __webpack_require__.e(7285), __webpack_require__.e(5522), __webpack_require__.e(4746), __webpack_require__.e(6717)]).then(__webpack_require__.bind(__webpack_require__, 56717));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56717)
            ];
        }
    },
    ssr: false
});
var ListingMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1572), __webpack_require__.e(2752), __webpack_require__.e(3801), __webpack_require__.e(5522), __webpack_require__.e(1248), __webpack_require__.e(5022)]).then(__webpack_require__.bind(__webpack_require__, 48533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48533)
            ];
        }
    },
    ssr: false
});
var CityPageHeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5736), __webpack_require__.e(4746), __webpack_require__.e(1307)]).then(__webpack_require__.bind(__webpack_require__, 54210));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54210)
            ];
        }
    },
    ssr: false
});
var getCleanedQueryParams = function(zone, query, city, canonicalUrlFilter) {
    var cleanedQueryParams = (0,helpers/* cleanQueryParams */.ZC)(query);
    if (zone) {
        cleanedQueryParams.byZone = cleanedQueryParams.byZone ? (0,_to_consumable_array/* default */.Z)(cleanedQueryParams.byZone).concat([
            zone
        ]) : [
            zone
        ];
    }
    if (city) {
        cleanedQueryParams.byZone = cleanedQueryParams.byZone && cleanedQueryParams.byZone.length > 0 ? cleanedQueryParams.byZone : [
            city
        ];
    }
    if (canonicalUrlFilter) {
        Object.keys(canonicalUrlFilter.filter).forEach(function(key) {
            cleanedQueryParams[key] = canonicalUrlFilter.filter[key];
        });
    }
    return cleanedQueryParams;
};
var ListingsByCityPageChild = function(param) {
    var canonicalFilter = param.canonicalFilter, city = param.city, geoSlugs = param.geoSlugs, user = param.user, zoneSlugSegment = param.zoneSlugSegment;
    var ref;
    var lang = (0,useTranslation/* default */.Z)().lang;
    var router = (0,next_router.useRouter)();
    var cities = (0,Cities/* useCities */.M1)();
    var ref1 = (0,CityPageContext/* useCityPage */.zh)(), setHasJustAppliedFilters = ref1.filters.setHasJustAppliedFilters, isMapFullPage = ref1.mapState.isMapFullPage, saveSearchButtonState = ref1.saveSearchButtonState;
    var device = (0,Device/* useDevice */.Fy)();
    var ref2 = (0,ModalContext/* useModal */.dd)(), closeZoneModal = ref2.closeModal, openZoneModal = ref2.openModal;
    var ref3 = (0,react.useState)(null), selectedPropertyId = ref3[0], setSelectedPropertyId = ref3[1];
    var zones = (0,react.useMemo)(function() {
        return (cities.router.city || cities.router.area).city_zones || [];
    }, [
        cities
    ]);
    var geoFilters = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(zones.map(function(item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                kind: "zone"
            });
        })).concat((0,_to_consumable_array/* default */.Z)(cities.list.map(function(cateCity) {
            return {
                kind: "city",
                label: cateCity.translatedCityName,
                referenceAreaSlug: cateCity.referenceArea,
                slug: cateCity.slug
            };
        })));
    }, [
        zones,
        cities
    ]);
    var componentMount = (0,react.useRef)(false);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useQueryParams */.Kx)(helpers/* queryParams */.SP), 2), query = ref4[0], setQuery = ref4[1];
    var cleanedQueryParams = getCleanedQueryParams(zoneSlugSegment, query, city, canonicalFilter);
    var DEFAULT_SORTING = types_sort/* SortBy.Ranking */.h.Ranking;
    var ref5 = (0,react.useState)((0,helpers/* cleanPriorityFilter */.x4)(cleanedQueryParams)), priorityFilters = ref5[0], setPriorityFilters = ref5[1];
    var ref6 = (0,react.useState)((0,helpers/* cleanOtherFilters */.I9)(cleanedQueryParams)), otherFilters = ref6[0], setOtherFilters = ref6[1];
    var ref7 = (0,react.useState)((0,_object_spread/* default */.Z)({}, (0,helpers/* cleanOtherFilters */.I9)(cleanedQueryParams), (0,helpers/* cleanPriorityFilter */.x4)(cleanedQueryParams))), allFilters = ref7[0], setAllFilters = ref7[1];
    var ref8 = (0,react.useState)((0,helpers/* cleanSortingParams */.IW)(cleanedQueryParams, DEFAULT_SORTING)), sort = ref8[0], setSort = ref8[1];
    var ref9 = (0,react.useState)((0,helpers/* cleanPageParams */.ID)(cleanedQueryParams)), page = ref9[0], setPage = ref9[1];
    var ref10 = (0,react.useState)(1), priorityPage = ref10[0], setPriorityPage = ref10[1];
    // TODO useZoneFilters should use NIKA instead of CATE-HASURA
    // const listingCountByZone = useZoneFilters(allFilters)
    var listingCountByZone = null;
    var queryFilter = (0,_object_spread/* default */.Z)({
        byGeoSlug: geoSlugs
    }, filters_mapper/* default.formatFiltersForQuery */.Z.formatFiltersForQuery(priorityFilters, geoFilters), otherFilters);
    var ref11 = useListings(sort, queryFilter, {
        page: page,
        page_size: helpers/* PAGINATION_SIZE */.hU
    }, {
        page: priorityPage,
        page_size: helpers/* PAGINATION_SIZE */.hU
    }), listingsData = ref11.data, isFetching = ref11.isFetching, isLoading = ref11.isLoading;
    var appliedGeoFilters = (0,react.useMemo)(function() {
        var appliedGeoFiltersSlugs = filters_mapper/* default.geoFilterToSlug */.Z.geoFilterToSlug(priorityFilters.byZone, geoFilters.map(function(gF) {
            return gF.slug;
        }));
        return geoFilters.filter(function(gF) {
            return appliedGeoFiltersSlugs.includes(gF.slug);
        });
    }, [
        priorityFilters,
        geoFilters
    ]);
    (0,react.useEffect)(function() {
        if (componentMount.current) {
            var newCleanedQueryParams = getCleanedQueryParams(zoneSlugSegment, query, city, canonicalFilter);
            var priorityFiltersParams = (0,helpers/* cleanPriorityFilter */.x4)(newCleanedQueryParams);
            var otherFiltersParams = (0,helpers/* cleanOtherFilters */.I9)(newCleanedQueryParams);
            var sortingParams = (0,helpers/* cleanSortingParams */.IW)(newCleanedQueryParams, DEFAULT_SORTING);
            var pageParams = (0,helpers/* cleanPageParams */.ID)(newCleanedQueryParams);
            setPriorityFilters(priorityFiltersParams);
            setOtherFilters(otherFiltersParams);
            setAllFilters((0,_object_spread/* default */.Z)({}, priorityFiltersParams, otherFiltersParams));
            setSort(sortingParams);
            // setSortPriority(sortingParams)
            setPage(pageParams);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        componentMount.current = true;
    }, []);
    (0,react.useEffect)(function() {
        if (listingsData === null || listingsData === void 0 ? void 0 : listingsData.priorities) {
            (0,eventsHandlers/* handleShow */.Hf)(eventCategory/* GTMEventCategory.ListingsPage */.z.ListingsPage, "PriorityAvailability-" + listingsData.priorities.potential_property_aggregate.aggregate.count);
        }
    }, [
        listingsData
    ]);
    var goToPathWithoutCanonicalFilter = function(sanitizedQueryParams) {
        var asPath = router.asPath;
        var cityRouter = asPath.split("?")[0].split("/").slice(0, 3).join("/");
        var formattedQueryParams = (0,querystring.stringify)((0,esm/* encodeQueryParams */.b4)(helpers/* queryParams */.SP, sanitizedQueryParams));
        router.push("".concat(cityRouter).concat(formattedQueryParams && "?").concat(new URLSearchParams(formattedQueryParams).toString()), null, {
            shallow: true
        });
    };
    var sanitizedFiltersWithOrWithoutZone = function(sanitizedFilters) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sanitizedFilters), {
            byZone: query.byZone ? priorityFilters.byZone : []
        });
    };
    var updateFilters = function(sanitizedFilters) {
        var isCanonicalFilterRemoved = (canonicalFilter === null || canonicalFilter === void 0 ? void 0 : canonicalFilter.filter) && Object.keys(canonicalFilter.filter).some(function(key) {
            return !isEqual_default()(canonicalFilter.filter[key], sanitizedFilters[key]);
        });
        if (isCanonicalFilterRemoved) {
            goToPathWithoutCanonicalFilter(sanitizedFiltersWithOrWithoutZone(sanitizedFilters));
        } else {
            setQuery(sanitizedFiltersWithOrWithoutZone(sanitizedFilters), "push");
        }
    };
    var onAddFilter = function(addedFilter) {
        var sanitizedFilters = sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query, allFilters, addedFilter), {
            pag: undefined
        }));
        updateFilters(sanitizedFilters);
    };
    var onRemoveFilter = function(filter) {
        var sanitizedFilters = sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, omit_default()(priorityFilters, filter.name), otherFilters), {
            pag: undefined
        }));
        updateFilters(sanitizedFilters);
    };
    var onChangeOtherFilters = function(updatedOtherFilters) {
        setHasJustAppliedFilters(true);
        var sanitizedFilters = sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            sorting: query.sorting
        }, priorityFilters, updatedOtherFilters), {
            pag: undefined
        }));
        updateFilters(sanitizedFilters);
    };
    var onRemoveAllFilters = function() {
        setHasJustAppliedFilters(false);
        var newFilters = Object.keys(priorityFilters).reduce(function(obj, key) {
            if (helpers/* skipFilters.includes */.Ft.includes(key)) obj[key] = priorityFilters[key];
            return obj;
        }, {});
        var sanitizedFilters = sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newFilters), {
            pag: undefined
        }));
        updateFilters(sanitizedFilters);
    };
    var onChangeSort = function(sortParam) {
        setQuery(sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            pag: undefined,
            sorting: sortParam
        })), "push");
    };
    var onChangePage = function(source, pageParam) {
        if (source === "priority") {
            setPriorityPage(pageParam);
            return;
        }
        setQuery(changePageUrl(pageParam));
    };
    var changePageUrl = function(pageParam) {
        return sanitizeNull((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            pag: pageParam
        }));
    };
    var changePageUrlString = function(pageParam) {
        var encodedQuery = (0,esm/* encodeQueryParams */.b4)(helpers/* queryParams */.SP, changePageUrl(pageParam));
        return "?".concat((0,querystring.stringify)(encodedQuery));
    };
    var handleOpenZoneFilter = function(event) {
        event.preventDefault();
        event.stopPropagation();
        openZoneModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(GeoFilterModal, {
            canonicalFilter: canonicalFilter,
            closeModal: function() {
                closeZoneModal();
            },
            initialFilters: appliedGeoFilters,
            listingCountByZone: listingCountByZone
        }), {
            desktopHeight: 590,
            desktopWidth: 640,
            overlay: true
        });
    };
    var listingsLength = listingsData === null || listingsData === void 0 ? void 0 : (ref = listingsData.listings) === null || ref === void 0 ? void 0 : ref.meta.total_objects;
    var hasListings = listingsLength > 0;
    var ref12 = (0,react.useState)(false), isTopListingsInView = ref12[0], setIsTopListingsInView = ref12[1];
    (0,usePageYOffset/* usePageYOffset */.S)(function(scrollY) {
        var ref;
        var firstListingThreshold = 220;
        var secondListingThreshold = 320;
        var listingThreshold = (listingsData === null || listingsData === void 0 ? void 0 : (ref = listingsData.listings) === null || ref === void 0 ? void 0 : ref.meta.total_objects) === 1 ? firstListingThreshold : secondListingThreshold;
        if (scrollY > listingThreshold) {
            setIsTopListingsInView(true);
        }
    });
    var ref13 = (0,react.useState)(false), hideSaveSearchAfterSearchSaved = ref13[0], setHideSaveSearchAfterSearchSaved = ref13[1];
    var noResults = !isFetching && !hasListings;
    var showSaveSearchBanner = device === "mobile" && !isMapFullPage && !hideSaveSearchAfterSearchSaved && isTopListingsInView && !noResults;
    (0,react.useEffect)(function() {
        if (saveSearchButtonState === "saved") {
            var feedbackDismiss = setTimeout(function() {
                setHideSaveSearchAfterSearchSaved(true);
            }, 1500);
            return function() {
                return clearTimeout(feedbackDismiss);
            };
        }
        if (saveSearchButtonState === "default") {
            setHideSaveSearchAfterSearchSaved(false);
        }
    }, [
        saveSearchButtonState
    ]);
    (0,useTagManager/* useTagManager */.F)({
        city: (cities.router.city || cities.router.area).name.toLowerCase(),
        language: lang,
        pageType: "listingsByCity"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrerenderedModal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbModal, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                contentWidth: "full",
                showFooterOnMobile: false,
                showHeaderOnMobile: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: cityPageWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPageHeaderMobile, {
                            appliedGeoFilters: appliedGeoFilters,
                            filters: allFilters,
                            geoSlugs: geoSlugs,
                            handleOpenZoneFilter: handleOpenZoneFilter,
                            onAddOtherFilters: onChangeOtherFilters,
                            onRemoveAllFilters: onRemoveAllFilters,
                            onRemoveFilter: onRemoveFilter
                        }),
                        (isMapFullPage || device === "desktop") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingMap, {
                            filters: queryFilter,
                            selectedPropertyId: selectedPropertyId,
                            onAddFilter: onAddFilter
                        }),
                        !isMapFullPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: contentPanel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingContent, {
                                    appliedGeoFilters: appliedGeoFilters,
                                    changePageUrl: changePageUrlString,
                                    filters: allFilters,
                                    geoFilters: geoFilters,
                                    geoSlugs: queryFilter.byGeoSlug,
                                    handleOpenZoneFilter: handleOpenZoneFilter,
                                    isLoading: isLoading,
                                    listingsAndPriorities: listingsData,
                                    listingsMeta: (0,listing_mapper/* nikaMetaToLegacyMeta */.Vy)(listingsData === null || listingsData === void 0 ? void 0 : listingsData.listings, page),
                                    page: page,
                                    priorityPage: priorityPage,
                                    sort: sort,
                                    onAddFilter: onAddFilter,
                                    onAddOtherFilters: onChangeOtherFilters,
                                    onChangePage: onChangePage,
                                    onChangeSort: onChangeSort,
                                    onListingCardHover: null,
                                    onRemoveAllFilters: onRemoveAllFilters,
                                    onRemoveFilter: onRemoveFilter
                                }),
                                (0,locale_variables/* isLocaleEnabledFor */.vw)("prerenderedSeoLinks", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PrerenderedSeoLinks, {
                                    canonicalFilter: canonicalFilter,
                                    isLoading: isFetching
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomContainerFixed/* MobileBottomContainerFixed */.g, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                        children: showSaveSearchBanner && (0,locale_variables/* isLocaleEnabledFor */.vw)("saveSearch", lang) && saveSearchButtonState === "default" && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SaveSearchFloatingBanner, {
                                            appliedGeoFilters: appliedGeoFilters,
                                            filters: allFilters,
                                            geoSlugs: geoSlugs,
                                            hasOnlyOneListing: listingsLength === 1
                                        })
                                    }),
                                    !isMapFullPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomMenu/* MobileBottomMenu */.V, {
                                        activeButton: "search"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ListingsByCityPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPageContext/* CityPageContextProvider */.kz, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingsByCityPageChild, (0,_object_spread/* default */.Z)({}, props))
    });
};


/***/ }),

/***/ 86099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LY": function() { return /* binding */ getZoneFromSegment; },
/* harmony export */   "lT": function() { return /* binding */ getPriorityWhereCondition; },
/* harmony export */   "ys": function() { return /* binding */ getPriorityGroupBy; }
/* harmony export */ });
/* unused harmony export mapStateOfMaintenance */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76131);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10145);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64635);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79328);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _types_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73534);
/* harmony import */ var _utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23040);






var getZoneFromSegment = function(zones, segment) {
    return segment ? zones.find(function(item) {
        return item.slug && (item === null || item === void 0 ? void 0 : item.slug.split("/")[2]) === segment;
    }) : null;
};
var mapResidentialType = function(residentialTypeFilter) {
    var residentialTypeEnumMap = {
        APARTMENT: "apartment",
        ATTIC: "attic",
        HOUSE: "house",
        LOFT: "loft",
        MANSARD: "mansard",
        TOWNHOUSE: "townhouse",
        VILLA: "villa"
    };
    return (residentialTypeEnumMap === null || residentialTypeEnumMap === void 0 ? void 0 : residentialTypeEnumMap[residentialTypeFilter]) || residentialTypeEnumMap;
};
var mapHeatingSystem = function(lisaHeatingSystemFilter) {
    var heatingEnumMap = {
        AUTONOMOUS: "independent",
        SHARED: "central"
    };
    return (heatingEnumMap === null || heatingEnumMap === void 0 ? void 0 : heatingEnumMap[lisaHeatingSystemFilter]) || lisaHeatingSystemFilter;
};
var mapStateOfMaintenance = function(lisaStateOfMaintenanceFilterList) {
    var maintenanceEnumMap = {
        FULLY_RENOVATED: "fully_renovated",
        HABITABLE: "habitable",
        NEED_RENOVATION: "need_renovation",
        NEW: "new",
        RENOVATED: "renovated",
        UNDER_CONSTRUCTION: "under_construction"
    };
    return lisaStateOfMaintenanceFilterList.reduce(function(acc, item) {
        if (item === "RENOVATED") return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(acc).concat([
            maintenanceEnumMap.RENOVATED,
            maintenanceEnumMap.FULLY_RENOVATED
        ]);
        var mappedValue = (maintenanceEnumMap === null || maintenanceEnumMap === void 0 ? void 0 : maintenanceEnumMap[item]) || item;
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(acc).concat([
            mappedValue
        ]);
    }, []);
};
var mapStateAtDeed = function(lisaStateAtDeedFilter) {
    var deedEnumMap = {
        FREE: "free",
        OCCUPIED: "occupied"
    };
    return (deedEnumMap === null || deedEnumMap === void 0 ? void 0 : deedEnumMap[lisaStateAtDeedFilter]) || lisaStateAtDeedFilter;
};
var getPriorityWhereCondition = function(filter) {
    var ref;
    var ref1 = lodash_mapValues__WEBPACK_IMPORTED_MODULE_2___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_0___default()((ref = filter.byGeoSlug) === null || ref === void 0 ? void 0 : ref.map(function(zone) {
        return zone.split("/");
    }), "length"), function(value) {
        return value.map(function(item) {
            return item.join("/");
        });
    }), cities = ref1[2], zones = ref1[3];
    return {
        _and: [
            {
                isPresentable: {
                    _eq: true
                }
            },
            {
                title: {
                    _is_null: false
                }
            },
            {
                rooms: {
                    _is_null: false
                }
            },
            {
                slug: {
                    _is_null: false
                }
            },
            {
                commercialArea: {
                    _is_null: false
                }
            },
            {
                bathrooms: {
                    _is_null: false
                }
            },
            {
                entranceFloor: {
                    _is_null: false
                }
            },
            {
                stateOfMaintenance: {
                    _is_null: false
                }
            },
            {
                residentialType: {
                    _is_null: false
                }
            },
            {
                insertedAt: {
                    _is_null: false
                }
            },
            {
                askedPriceInCents: {
                    _is_null: false
                }
            },
            {
                _or: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(zones ? [
                    {
                        zoneSlug: {
                            _in: zones
                        }
                    }
                ] : []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(cities ? [
                    {
                        city: {
                            _in: cities
                        }
                    }
                ] : []))
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byBathrooms) ? [
            {
                bathrooms: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(filter.byBathrooms)
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byPrice) ? [
            {
                _or: [
                    {
                        askedPriceInCents: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(lodash_mapValues__WEBPACK_IMPORTED_MODULE_2___default()(filter.byPrice, function(x) {
                            return lodash_isNil__WEBPACK_IMPORTED_MODULE_1___default()(x) ? null : x * 100;
                        }))
                    },
                    {
                        valuationPriceInCents: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(lodash_mapValues__WEBPACK_IMPORTED_MODULE_2___default()(filter.byPrice, function(x) {
                            return lodash_isNil__WEBPACK_IMPORTED_MODULE_1___default()(x) ? null : x * 100;
                        }))
                    }, 
                ]
            }, 
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byRooms) ? [
            {
                rooms: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(filter.byRooms)
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byArea) ? [
            {
                commercialArea: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(filter.byArea)
            }
        ] : []), // tipologia
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byResidentialType) ? [
            {
                residentialType: {
                    _in: filter.byResidentialType.map(mapResidentialType)
                }
            }
        ] : []), // no bedrooms
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byBathrooms) ? [
            {
                bathrooms: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(filter.byBathrooms)
            }
        ] : []), // TBD piano - byFloors
        // stateOfMaitenance
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(filter.byStateOfMaintenance ? [
            {
                stateOfMaintenance: {
                    _in: mapStateOfMaintenance(filter.byStateOfMaintenance)
                }
            }
        ] : []), // stateAtDeed
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(filter.byStateAtDeed ? [
            {
                stateAtDeed: {
                    _in: filter.byStateAtDeed.map(mapStateAtDeed)
                }
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithElevator) ? [
            {
                hasElevator: {
                    _eq: true
                }
            }
        ] : []), // no parking
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithBox) ? [
            {
                boxAreas: {
                    _is_null: false
                }
            }
        ] : []), // no basement cantina
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithGarden) ? [
            {
                gardenArea: {
                    _is_null: false
                }
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithBalcony) ? [
            {
                balconies: {
                    _is_null: false
                }
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithTerrace) ? [
            {
                terraceAreas: {
                    _is_null: false
                }
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.onlyWithPool) ? [
            {
                hasPool: {
                    _eq: true
                }
            }
        ] : []), // no aria condizionata
        // no concierge
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byHeatingSystem) ? [
            {
                heatingSystem: {
                    _in: filter.byHeatingSystem.map(mapHeatingSystem)
                }
            }
        ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((filter === null || filter === void 0 ? void 0 : filter.byConstructionYear) ? [
            {
                constructionYear: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapIntRangeFilter */ .ER)(filter.byConstructionYear)
            }
        ] : []))
    };
};
var getPriorityGroupBy = function(param) {
    var by = param.by, direction = param.direction;
    if (!by) {
        return {
            updatedAt: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapSortDirection */ .fn)(direction)
        };
    }
    switch(by){
        case _types_sort__WEBPACK_IMPORTED_MODULE_3__/* .SortBy.Area */ .h.Area:
            return {
                commercialArea: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapSortDirection */ .fn)(direction)
            };
        case _types_sort__WEBPACK_IMPORTED_MODULE_3__/* .SortBy.Date */ .h.Date:
        case _types_sort__WEBPACK_IMPORTED_MODULE_3__/* .SortBy.Ranking */ .h.Ranking:
            return {
                updatedAt: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapSortDirection */ .fn)(direction)
            };
        case _types_sort__WEBPACK_IMPORTED_MODULE_3__/* .SortBy.Price */ .h.Price:
            return {
                askedPriceInCents: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapSortDirection */ .fn)(direction)
            };
        default:
            return {
                updatedAt: (0,_utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_4__/* .mapSortDirection */ .fn)(direction)
            };
    }
};


/***/ }),

/***/ 88108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ skipFilters; },
/* harmony export */   "I9": function() { return /* binding */ cleanOtherFilters; },
/* harmony export */   "ID": function() { return /* binding */ cleanPageParams; },
/* harmony export */   "IW": function() { return /* binding */ cleanSortingParams; },
/* harmony export */   "SP": function() { return /* binding */ queryParams; },
/* harmony export */   "ZC": function() { return /* binding */ cleanQueryParams; },
/* harmony export */   "hU": function() { return /* binding */ PAGINATION_SIZE; },
/* harmony export */   "x4": function() { return /* binding */ cleanPriorityFilter; }
/* harmony export */ });
/* unused harmony exports mapSort, mapPaginate, mapFilter, priorityFilter, MARKER_PAGINATION_SIZE, MARKER_QUERY_SIZE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65594);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62271);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10145);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21781);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64635);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79328);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5365);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_omitBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var use_query_params__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8300);
/* harmony import */ var _types_sort__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73534);
/* harmony import */ var _utils_graphql_filter_mapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23040);











var mapSort = function(by, direction) {
    if (by === null) {
        return {
            ranking: mapSortDirection(direction)
        };
    }
    switch(by){
        case SortBy.Area:
            return {
                detail: {
                    commercialArea: mapSortDirection(direction)
                }
            };
        case SortBy.Date:
            return {
                publishedAt: mapSortDirection(direction)
            };
        case SortBy.Price:
            return {
                detail: {
                    sellingPrices: {
                        cents: mapSortDirection(direction)
                    }
                }
            };
        case SortBy.Ranking:
            return {
                ranking: mapSortDirection(direction)
            };
    }
};
var mapPaginate = function(paginate) {
    var ref;
    var sizeWithDefault = (ref = paginate === null || paginate === void 0 ? void 0 : paginate.size) !== null && ref !== void 0 ? ref : 0;
    var ref1;
    var pageWithDefault = (ref1 = paginate === null || paginate === void 0 ? void 0 : paginate.page) !== null && ref1 !== void 0 ? ref1 : 0;
    var ref2;
    return {
        limit: (ref2 = paginate === null || paginate === void 0 ? void 0 : paginate.size) !== null && ref2 !== void 0 ? ref2 : null,
        offset: Math.max(sizeWithDefault * (pageWithDefault - 1), 0)
    };
};
var mapFilter = function(filter, citiesCate) {
    var ref, ref1, ref2;
    var geoSlugFilter = mapValues(groupBy((ref = filter.byGeoSlug) === null || ref === void 0 ? void 0 : ref.map(function(zone) {
        return zone.split("/");
    }), "length"), function(value) {
        return value.map(function(item) {
            return item.join("/");
        });
    });
    return omitBy({
        _and: _object_spread({}, omitBy({
            _and: {
                _or: [
                    (ref1 = filter.byFloor) === null || ref1 === void 0 ? void 0 : ref1.map(function(floor) {
                        return {
                            detail: {
                                floorPosition: {
                                    _contains: floor.toLowerCase()
                                }
                            }
                        };
                    }), 
                ].flat(1).map(function(item) {
                    return omitBy(item, isNil || isEmpty);
                }).filter(function(item) {
                    return Boolean(item) && !isEmpty(item);
                })
            }
        }, function(item) {
            return isEmpty(item._or);
        }), omitBy({
            _or: [
                omitBy({
                    detail: omitBy({
                        city: mapArrayFilter((ref2 = geoSlugFilter["2"]) === null || ref2 === void 0 ? void 0 : ref2.map(function(slug) {
                            var ref, ref1;
                            return (ref = citiesCate.find(function(city) {
                                return city.slug === slug;
                            })) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                        }))
                    }, isNil || isEmpty)
                }, isEmpty),
                omitBy({
                    detail: {
                        zone: mapComparisonExp("slug", mapArrayFilter(geoSlugFilter["3"]))
                    }
                }, function(item) {
                    return isNil(item.zone);
                }), 
            ].flat(1).map(function(item) {
                return omitBy(item, isNil || isEmpty);
            }).filter(function(item) {
                return Boolean(item) && !isEmpty(item);
            })
        }, isEmpty)),
        additionalInfo: omitBy({
            constructionYear: omitBy(mapIntRangeFilter(filter.byConstructionYear), isNil),
            coolingSystem: omitBy(mapArrayFilter(filter.onlyWithCoolingSystem ? [
                "autonomous",
                "ready_for_installation",
                "shared"
            ] : [] // TODO: we could use _nin instead of _in to semplify the where's value
            ), isNil),
            heatingSystem: omitBy(mapArrayFilter(filter.byHeatingSystem), isNil),
            stateAtDeed: omitBy(mapArrayFilter(filter.byStateAtDeed), isNil)
        }, isEmpty),
        characteristics: omitBy({
            balconies: mapCounter(mapBooleanFilterToIntComparison(filter.onlyWithBalcony)),
            bathrooms: mapIntRangeFilter(filter.byBathrooms),
            bedrooms: mapIntRangeFilter(filter.byBedrooms),
            rooms: mapIntRangeFilter(filter.byRooms),
            stateOfMaintenance: mapArrayFilter(filter.byStateOfMaintenance),
            terraces: mapCounter(mapBooleanFilterToIntComparison(filter.onlyWithTerrace))
        }, isEmpty),
        contactInfo: omitBy({
            ownedByCasavo: mapBooleanFilter(filter.onlyCasavo)
        }, isEmpty),
        detail: omitBy({
            commercialArea: mapIntRangeFilter(filter.byArea),
            sellingPrices: mapComparisonExp("cents", mapIntRangeFilter(mapValues(filter.byPrice, function(x) {
                return isNil(x) ? null : x * 100;
            })))
        }, isEmpty),
        residentialType: mapArrayFilter(filter.byResidentialType),
        services: omitBy({
            basement: mapBooleanFilter(filter.onlyWithBasement),
            box: mapCounter(mapBooleanFilterToIntComparison(filter.onlyWithBox)),
            conciergeService: mapBooleanFilter(filter.onlyWithConciergeService),
            elevator: mapBooleanFilter(filter.onlyWithElevator),
            garden: mapBooleanFilter(filter.onlyWithGarden),
            parkingSpaces: mapBooleanFilter(filter.onlyWithParking),
            pool: mapBooleanFilter(filter.onlyWithPool)
        }, isEmpty)
    }, isEmpty);
};
var priorityFilter = [
    "byPrice",
    "byRooms",
    "byArea"
];
var skipFilters = [
    "onlyCasavo",
    "byZone"
];
var queryParams = {
    byArea: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byBathrooms: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byBedrooms: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byConstructionYear: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byFloor: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    byHeatingSystem: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    byPrice: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byResidentialType: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    byRooms: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumericObjectParam */ ._c,
    byStateAtDeed: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    byStateOfMaintenance: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    byZone: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ArrayParam */ .V3,
    onlyCasavo: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithBalcony: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithBasement: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithBox: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithConciergeService: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithCoolingSystem: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithElevator: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithGarden: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithParking: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithPool: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    onlyWithTerrace: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .BooleanParam */ .dJ,
    pag: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .NumberParam */ .yz,
    sorting: use_query_params__WEBPACK_IMPORTED_MODULE_5__/* .ObjectParam */ .A9
};
var PAGINATION_SIZE = 20;
var MARKER_PAGINATION_SIZE = 500;
var MARKER_QUERY_SIZE = 50;
var cleanQueryParams = function(queryParams) {
    return Object.keys(queryParams).reduce(function(acc, key) {
        if (queryParams[key] === undefined || queryParams[key] === null) {
            return acc;
        }
        if (typeof queryParams[key] === "object" && Object.keys(queryParams[key]).length === 0) {
            return acc;
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, key, queryParams[key]));
    }, {});
};
var cleanPriorityFilter = function(cleanedQueryParams) {
    return Object.keys(cleanedQueryParams).reduce(function(acc, key) {
        if (priorityFilter.includes(key) || skipFilters.includes(key)) {
            var queryParamsFilter = cleanedQueryParams[key];
            if (queryParamsFilter && typeof queryParamsFilter !== "boolean" && key !== "byZone") {
                var filter = {
                    from: queryParamsFilter.from ? queryParamsFilter.from : null,
                    to: queryParamsFilter.to ? queryParamsFilter.to : null
                };
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, key, filter));
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, key, queryParamsFilter));
        }
        return acc;
    }, {});
};
var cleanOtherFilters = function(cleanedQueryParams) {
    return Object.keys(cleanedQueryParams).reduce(function(acc, k) {
        var key = k.trim();
        if (key !== "sorting" && key !== "pag" && !priorityFilter.includes(key) && !skipFilters.includes(key)) {
            var filter = cleanedQueryParams[key];
            if (key === "byConstructionYear") {
                filter = cleanedQueryParams[key];
                if (filter) {
                    if (!filter.to) {
                        filter.to = null;
                    }
                    if (!filter.from) {
                        filter.from = null;
                    }
                }
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, key, filter));
        }
        return acc;
    }, {});
};
var cleanSortingParams = function(cleanedQueryParams) {
    var defaultSortBy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _types_sort__WEBPACK_IMPORTED_MODULE_6__/* .SortBy.Ranking */ .h.Ranking;
    var ref, ref1;
    return {
        by: ((ref = cleanedQueryParams["sorting"]) === null || ref === void 0 ? void 0 : ref.by) || defaultSortBy,
        direction: ((ref1 = cleanedQueryParams["sorting"]) === null || ref1 === void 0 ? void 0 : ref1.direction) || _types_sort__WEBPACK_IMPORTED_MODULE_6__/* .SortDirection.Desc */ .S.Desc
    };
};
var cleanPageParams = function(queryParams) {
    return Object.keys(queryParams).reduce(function(acc, key) {
        var pageKey = "pag";
        var page = queryParams[pageKey];
        return key.trim() === pageKey && page >= 1 ? page : acc;
    }, 1);
};


/***/ }),

/***/ 73534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SortDirection; },
/* harmony export */   "h": function() { return /* binding */ SortBy; }
/* harmony export */ });
var SortBy;
(function(SortBy) {
    SortBy["Area"] = "AREA";
    SortBy["Date"] = "DATE";
    SortBy["Price"] = "PRICE";
    SortBy["Ranking"] = "RANKING";
})(SortBy || (SortBy = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));


/***/ }),

/***/ 23040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ mapIntRangeFilter; },
/* harmony export */   "fn": function() { return /* binding */ mapSortDirection; }
/* harmony export */ });
/* unused harmony exports mapBooleanFilter, mapBooleanFilterToIntComparison, mapArrayFilter, mapComparisonExp, mapCounter */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65594);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61978);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types_cate_graphql_generated_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73559);
/* harmony import */ var _types_graphql_generated_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98733);




var mapIntRangeFilter = function(filter) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(filter === null || filter === void 0 ? void 0 : filter.from) && (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(filter === null || filter === void 0 ? void 0 : filter.to) ? null : (0,lodash__WEBPACK_IMPORTED_MODULE_0__.omitBy)({
        _gte: filter === null || filter === void 0 ? void 0 : filter.from,
        _lte: filter === null || filter === void 0 ? void 0 : filter.to
    }, lodash__WEBPACK_IMPORTED_MODULE_0__.isNil);
};
var mapBooleanFilter = function(filter) {
    return isNil(filter) || !filter ? null : {
        _eq: filter
    };
};
var mapBooleanFilterToIntComparison = function(filter) {
    return isNil(filter) ? null : {
        _gte: filter ? 1 : 0
    };
};
var mapArrayFilter = function(filter) {
    return isNil(filter) || filter.length === 0 ? null : {
        _in: filter === null || filter === void 0 ? void 0 : filter.map(function(x) {
            return x.toLowerCase();
        })
    };
};
var mapComparisonExp = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.curry)(function(key, filter) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(filter) || Array.isArray(filter) && filter.length === 0 || typeof filter === "string" && filter.length === 0 ? null : (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, filter);
});
var mapSortDirection = function(direction) {
    return direction === _types_graphql_generated_types__WEBPACK_IMPORTED_MODULE_2__/* .SortDirection.Asc */ .Sr.Asc ? _types_cate_graphql_generated_types__WEBPACK_IMPORTED_MODULE_1__/* .Order_By.AscNullsLast */ .Lq.AscNullsLast : _types_cate_graphql_generated_types__WEBPACK_IMPORTED_MODULE_1__/* .Order_By.DescNullsLast */ .Lq.DescNullsLast;
};
var mapCounter = mapComparisonExp("counter");


/***/ }),

/***/ 11127:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40473:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 17789:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 64849:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98026:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 85979:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82534:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);